import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"

declare var require: any;

@Injectable({
  providedIn: 'root',
})
export class ConstantsService {
  //images
  public WS_survy_mobile = 'assets/images/WindowSwap_Survey 1.png';
  public WS_tipjar_mobile = 'assets/images/tipjar-mobile.png';
  public WS_MUSIC_TEXT = 'assets/images/The WS Music Video.png';
  public WS_MUSIC = 'assets/images/window_swap_music.png';

  public MAP_MARKER_IMG = 'assets/images/maplocation.png';
  public MAP_CLUSTER_IMG = 'assets/images/cluster.png';
  public MAP_BACK_BUTTON = 'assets/images/mapbackbutton.png';

  public MAP_SEARCH_TEXTFIELD_ICON = 'assets/images/MAP_SEARCH_TEXTFIELD_ICON.png';
  public SEARCH_CLOSE = 'assets/images/closebutton1.png';

  public MAP_CITY_IMG = 'assets/images/mapcity.png';
  public MAP_NATURE_IMG = 'assets/images/mapnature.png';
  public MAP_PETS_IMG = 'assets/images/mappets.png';
  public MAP_RAIN_IMG = 'assets/images/maprain.png';
  public MAP_SNOW_IMG = 'assets/images/mapsnow.png';
  public MAP_NIGHT_IMG = 'assets/images/mapnight.png';
  public MAP_WATER_IMG = 'assets/images/watericon-small.png';

  public updated_Glassy_IMG_1 = 'assets/images/updated_cross_IMG.png';
  public updated_Glassy_IMG = 'assets/images/updated_Glassy_card.png';
  public naturing_IMG = 'assets/images/naturings.png';
  public WATER_IMAGE = 'assets/images/WaterIcon.png';
  public snowloader_IMG = 'assets/images/snowings.png';
  public nighting_IMG = 'assets/images/nighting.png';
  public ranies_IMG = 'assets/images/rainies.png';
  public peties_IMG = 'assets/images/peties.png';
  public city_IMG = 'assets/images/cities.png';
  public interiorloader_IMG = 'assets/images/interiors.png';
  public EDIT_BUTTON = 'assets/images/edit.png';
  public Back_TAG_IMG = 'assets/images/backtgimg.png';
  public submit_btn_1 = 'assets/images/Submit button_1.png';
  public submit_btn = 'assets/images/sub_button.png';
  public WINDOW_GlassyCard = 'assets/images/window_Glassy card.png';
  public WINDOW_SWAP = 'assets/images/windowSwap.png';
  public THE_TIP_JAR = 'assets/images/theTipjar.png';
  public GLASYY_IMG = 'assets/images/Glassycard_image.png';
  public FILTER_BUTTON = 'assets/images/filter_button.png';
  public NEWS_IMG = 'assets/images/News.png';
  public INSTAGREM_IMG = 'assets/images/insta.png';
  public CONTACT_IMG = 'assets/images/Information.png';
  public TERMS_IMG = 'assets/images/termsandcondition.png';
  public blurb_img = 'assets/images/Glassycard.png';
  public blurb_img_2 = 'assets/images/Glassy_card_2.png';

  public CITY_IMG = 'assets/images/city.png';
  public PETS_IMG = 'assets/images/pets.png';
  public RAIN_IMG = 'assets/images/rain.png';
  public SNOW_IMG = 'assets/images/snow.png';
  public NIGHT_IMG = 'assets/images/night.png';
  public WATER_IMG = 'assets/images/watericon-small.png';
  public NATURE_IMG = 'assets/images/nature.png';
  public INTERIOR_IMG = 'assets/images/Interior_image.png';
  public Back_ARROW_IMG = 'assets/images/Back button.png';
  public Back_button = 'assets/images/Back button.png';
  public DEVICE_IMG = 'assets/images/device.png';
  public HOME_BG_IMG = 'assets/images/homebg.gif';
  public ARROW_IMG = 'assets/images/arrow.png';
  public VIMEO_IMG = 'assets/images/poweredByVimeo.png';
  public PIN_IMG = 'assets/images/location_pin.png';
  public LOCATION_PING = 'assets/images/location_ping.svg';
  public FAVORITE_OFF_IMG = 'assets/images/favorite_off.png';
  public FAVORITE_OFF_IMG_MOBILE = 'assets/images/favorite_off_mobile.svg';
  public FAVORITE_ON_IMG = 'assets/images/favorite_on.png';
  public FAVORITE_ON_IMG_MOBILE = 'assets/images/favorite_on_1.svg';
  public VOLUME_ON_IMG = 'assets/images/vButtonOn.png';
  public VOLUME_ON_IMG_MOBILE = 'assets/images/vButtonOn_1.svg';
  public VOLUME_OFF_IMG = 'assets/images/vButtonOff.png';
  public VOLUME_OFF_IMG_MOBILE = 'assets/images/vButtonOff_13.png';
  public CLOSE_BUTTON = 'assets/images/close_button.png';
  public PROFILE_USER_IMG = 'assets/images/Menu-user.png';
  public BACK_BUTTON = 'assets/images/back.png';
  public LOGIN_CLOSE_BUTTON = 'assets/images/closeButtonGreen.png';
  public SUBMIT_BTN_IMG = 'assets/images/submit.png';
  public LOOP_BTN_IMG = 'assets/images/loop.png';
  public LOOP_BTN_IMG_MOBILE = 'assets/images/loop_1.svg';
  public SHARE_BTN_IMG = 'assets/images/Share Button.png';
  public SHARE_BTN_MOBILE = 'assets/images/Share_1.svg';
  public SHUFFLE_IMG = 'assets/images/shuffle.png';
  public SHUFFLE_IMG_MOBILE = 'assets/images/shuffle_1.svg';
  public INSTAGRAM_IMG = 'assets/images/instagram-small.png';
  public COFFEECUP_IMG = 'assets/images/coffeecup.png';
  public RIGHT_ARROW_BLACK_IMG = 'assets/images/rightArrowBlack.png';
  public POPUP_BEFORE_IMG = 'assets/images/popupBeforeLogin.png';
  public POPUP_BEFOER_HOME_IMG = 'assets/images/homepopupBeforeLogin.png';
  public POPUP_AFTER_IMG = 'assets/images/popupAfterLogin.png';
  public SUBMITWINDOW_IMG = 'assets/images/SubmitWindow.png';
  public FACEBOOK_SHARE_IMG = 'assets/images/facebook.png';
  public WHATSAPP_SHARE_IMG = 'assets/images/whatsapp.png';
  public TWITTER_SHARE_IMG = 'assets/images/twitter.png';
  public COPY_LINK_IMG = 'assets/images/CopyLink.png';
  public BOOKMARK_POPUP_IMG = 'assets/images/windowpopupimg.png';
  public MENU_ICON_IMG = 'assets/images/Group 5.png';
  public MENU_ICONS_IMG = 'assets/images/hamburger.png';
  public SIGNUP_PAGE_IMG = 'assets/images/signuppage.png';
  public LOGIN_PAGE_IMG = 'assets/images/loginpage.png';
  public SUBMIT_LOGIN_IMG = 'assets/images/submit-login.png';
  public LOGIN_FACEBOOK_IMG = 'assets/images/Facebook-icon.png';
  public LOGIN_GOOGLE_IMG = 'assets/images/google_icon.png';
  public BOOMARK_ICON_IMG = 'assets/images/bookmaricon.png';
  public EMPTY_BOOKMAR_IMG = 'assets/images/emptyBookmark.png';
  public SKELTON_PROFILE_IMG = 'assets/images/cardskeltonloading.png';
  public SKELTON_CARD_IMG = 'assets/images/skeltoncard.png';
  public BLOG_IMG = 'assets/images/blog.png';
  public CONTATC_IMG = 'assets/images/contact.png';
  public FAVORITE_IMG = 'assets/images/favorite.png';
  public WINDOW_SWAP_IMG = 'assets/images/WindowSwap_logo.png';
  public ADD_BUTTON_IMG = 'assets/images/add-button.png';
  public READY_TO_UPLOAD_IMG = 'assets/images/readyto-upload.png';
  public APPROVED_WINDOW = 'assets/images/Approved 1.png';
  public ON_DROP_IMG = 'assets/images/on-drop.png';
  public SUBMIT_THANK_IMG = 'assets/images/submit-thank.png';
  public SUBMIT_THANK_IMG_1 = 'assets/images/success-img-1.png';
  public BOOKMARK_ALERT_IMG = 'assets/images/bookmark-alert-img.png';
  public LOCATION_ALERT_IMG = 'assets/images/location-alert-img.png';
  public CHECKBOX_IMG = 'assets/images/checkbox.png';
  public CLOSE_IMG = 'assets/images/close.png';
  public POPUP_MYWINDOW_IMG = 'assets/images/my-pop.png';
  public VIEW_IMG = 'assets/images/view.png';
  public DELETE_IMG = 'assets/images/Trash 1.png';
  public EDIT_IMG = 'assets/images/editImage.png';
  public MY_WINDOW_SKELTON_IMG = 'assets/images/skelton-mywindow.png';
  public CHECKBOX_GREEN_IMG = 'assets/images/checkbox-green.png';
  public CLOSE_GREEN_IMG = 'assets/images/close_button.png';
  public CHECKBOX_WHITE_IMG = 'assets/images/editEllipse.png';
  public EDIT_CLOSE = 'assets/images/edit-close.png';
  public CLOSE_WHITE_IMG = 'assets/images/editCloseVector.png';
  public PENDING_SKELTON_IMG = 'assets/images/pending-skelton.png';
  public PLAYER_SKELTON_IMG = 'assets/images/player-skelton.png';
  public TAG_SKELTON_IMG = 'assets/images/tag-skelton.png';
  public VIDEO_TITLE_SKELTON_IMG = 'assets/images/video-title-skelton.png';
  public UPLOADED_SKELTON_IMG = 'assets/images/uploaded-skelton.png';
  public BASKET_IMG = 'assets/images/basket.png';
  public MAIL_IMG = 'assets/images/mail-icon.png';
  public AVATAR_IMG = 'assets/images/avatar.jpg';
  public VELUX_LOGO_IMG = 'velux/velux-logo.png';
  public S_IMG = 'assets/images/image 1.png';
  public TIPSJAR_LOAD1_IMG = 'assets/images/load1.png';
  public TIPSJAR_LOAD2_IMG = 'assets/images/load2.png';
  public TIPSJAR_LOAD3_IMG = 'assets/images/load3.png';
  public TIPS_BLURB_IMG = 'assets/images/tips-blurb.png';
  public tips_1_IMG = 'assets/images/tips 1.png';
  public tips_2_IMG = 'assets/images/Tips 1 (1).png';
  public thanks_IMG = 'assets/images/thanks 1.png';
  public vector_IMG = 'assets/images/Vector.png';
  public DEMO_THUMBNAIL = 'assets/images/TwitterCardImg.png';
  public CARDS_IMG = 'assets/images/cards.png';
  public PAYPA_IMG = 'assets/images/paypa.png';
  public PAYMENT_ALERT_IMG = 'assets/images/payment-alert.png';
  public PAYMENT_ALERT_IMG_NEW = 'assets/images/payment-alert-new.png';
  public GOTO_PREV_IMG = 'assets/images/gotoprev.png';
  public GOTO_PREV_IMG_MOBILE = 'assets/images/gotoprev_1.svg';

  public LOCK_IMG = 'assets/images/Lock_IMG.png';
  public MORE_IMG = 'assets/images/more.png';
  public PRIME_IMG = 'assets/images/prime.png';
  public ARROEPRIME_IMG = 'assets/images/arrowprime.png';
  public MEMBERSKEL_IMG = 'assets/images/memberskelten.png';
  public WINDOW_SWAP_GREEN_IMG = 'assets/images/WindowSwap_logo Green_large.png';
  public MAP_SEARCH = 'assets/images/search.png';
  public MAP_SEARCH_MOBILE = 'assets/images/Search_1.svg';
  public SEARCH_NO_SHADOW_IMG = 'assets/images/seach_no_shadow.png';
  public FULL_SCREEN_ICON = 'assets/images/FullScreenIcon.png';
  public FULL_SCREEN_ICON_MOBILE = 'assets/images/FullScreenIcon_1.svg';
  public FULL_SCREEN_ICON_OUT = 'assets/images/Remove-full-screen-icon.png';
  public FULL_SCREEN_ICON_OUT_MOBILE = 'assets/images/Remove-full-screen-icon_1.svg';
  public TICK_GREEN = 'assets/images/Tick-green.png';
  public TICK_ORANGE = 'assets/images/Tick-orange.png';
  public MAP_PREVIEW = 'assets/images/Map-preview.png';
  public MAP_PREVIEW_NON_PRIME = 'assets/images/nonPrimeMap.png';
  public PLAY_LIST_MODULE = 'assets/images/Playlist-module.png';
  public PAYMENT_SUCCESS = 'assets/images/payment-success-img.png';
  public NOT_PRIME_MAP = 'assets/images/map-notprime.png';
  public AFTER_5_10_VIDEOS = 'assets/images/after-5-10-videos.png';
  public PLAYLIST_MODULE = 'assets/images/Playlists-module.png';
  public VIATOR_IMG = 'assets/images/viator.png';
  public VIATOR_IMG_NO_BG = 'assets/images/viator-logo-green.png';
  public BOOKMARKED_LOOP = 'assets/images/bookmarked-loop.png';
  public GREEN_BOOKMARKED_ICON = 'assets/images/green-profile-icon.png';
  public GREEN_HAMBURG_USER_PROFILE = 'assets/images/Menu-userprofile.png';
  public BACK_BUTTON_BOOKMARK = 'assets/images/back-button-bookmark.png';
  public BOOKMARK_LOOP_OFF = 'assets/images/Bookmark_loop_off.png';
  public BOOKMARK_CLOSE_BUTTON = 'assets/images/close-button-bookmark.png';
  public BOOKMARK_SHUFFLE_OFF = 'assets/images/SHUFFLE OFF.png';
  public BOOKMARK_SHUFFLE_OFF_MOBILE = 'assets/images/SHUFFLE OFF_1.svg';
  public BOOKMARK_SHUFFLE_ON = 'assets/images/SHUFFLE ON.png';
  public BOOKMARK_SHUFFLE_ON_MOBILE = 'assets/images/SHUFFLE ON_1.svg';
  public PLAYLIST_NO_ACCESS = 'assets/images/Playlists_not_access.png';
  public MOBILE_MENU = 'assets/images/Menu-mobile.png';
  public ERROR_IMG = 'assets/images/WindowSwap-error-whenlink - isalready-confirmed.png';

  public CARD_IMG = [
    { brand: 'Visa', img: 'assets/images/card-image/visa.png' },
    { brand: 'MasterCard', img: 'assets/images/card-image/master.png' },
    { brand: 'American Express', img: 'assets/images/card-image/amex.png' },
    { brand: 'UnionPay', img: 'assets/images/card-image/union_pay.jpg' },
  ];

  public MOBILE_MENU_USER_SETTING_MOB = 'assets/images/menuicon.png';
  public SUBMIT_WINDOW_ICON = 'assets/images/SUBMIT ICON.png';
  public SUBMIT_WINDOW_ICON1 = 'assets/images/SUBMIT ICON1.png';
  public USER_ICON = 'assets/images/Vector.png';
  public WINDOW_MENU = 'assets/images/windowMenu.png';
  public USER_ICON_BLUE = 'assets/images/user_icon_blue.png';
  public ERROR_ICON_SUBMIT = 'assets/images/submit-error.png';
  public VERTICAL_VIDEO = 'assets/images/verticalVideo.png';
  public LOWRES_VIDEO = 'assets/images/lowRes.png';
  public CLOSE_ICON_SUBMIT = 'assets/images/CLOSE BUTTON.png';
  public INS_ICON = 'assets/images/Instagram.png';
  public NEW_GIFT_PAYMENT = 'assets/images/News_1.png';
  public NEW_CONTACT_PAYMENT = 'assets/images/contact_1.png';
  public NEW_TERMS_PAYMENT = 'assets/images/T_C.png';
  public TICK = 'assets/images/tick.png';
  public BROKEN_IMG = 'assets/images/broken_video.jpg';

  // { brand: "abc", img: 'assets/images/card-image/diners_club.png' },
  // { brand: "afs", img: 'assets/images/card-image/discover.png' },
  // { brand: "ags", img: 'assets/images/card-image/jcb.png' },

  //Text messages
  public WINDOW_SWAP_TXT = 'WindowSwap';
  public SIGNUP_FB = 'Sign up with FB'
  public PASSWORD = 'Please enter a password'
  public ENTER_CARD_TXT = "Please enter your card number"
  public EMPTY_TXT = 'empty'
  public NAME_MAXLENGTH_ERROR_TEXT = 'Name must not exceed 25 characters'
  public LOCATION_MAXLENGTH_ERROR_TEXT = 'Location must not exceed 25 characters'
  public VALIDATION_ERROR_TXT = 'Your card number, expiry or cvc is incomplete.'
  public VALIDATION_ERROR_KEY = 'validation_error'
  public STRONG_PASSWORD = 'A strong password is at least 8 characters and a mix of uppercase, and lowercase letters, symbols($@#!%*?&), and numbers.'
  public SIGNUP_GOOGLE = 'Sign up with Google'
  public CREATE_ACCOUNT = 'Create an account'
  public SIGNUP_EMAIL = 'Sign up with email'
  public EMAIL_ID = '   Please enter an email ID '
  public ANOTHER_EMAIL = '   You already have an account with this email. '
  public ENTER_NAME = '   Please enter your name '
  public INVALID_ID = 'Invalid Email ID'
  public TAG_1_TXT = 'Altan - Rome, Italy'
  public TAG_2_TXT = 'Kurt - Vid, Austria'
  public ALREADY_TXT = 'Already have an account?'
  public BLOG_TXT = 'About';
  public CONTACT_TXT = 'Contact';
  public SUBMIT_WINDOW_TXT = 'Submit your window';
  public OPEN_WINDOW_TXT = 'Open a window somewhere in the world';
  public OPEN_A_WINDOW_TXT = 'Open a new window';
  public INSTAGRAM_TXT = 'Instagram';
  public YOUR_PROFILE = 'Your profile';
  public BUYUSACOFFEE_TXT = 'Buy us a coffee';
  public ARE_YOU_TXT = 'Are you sure you want to delete this window?';
  public DELETE_TEXT="Are you sure you want to delete this window forever?";
  public ARE_YOU_SUBSCRIPTION_CANCEL_TXT = 'Your Subscription will be cancelled Immediately';
  public ARE_YOU_SUBSCRIPTION_TXT = 'Are you sure you want to continue?';
  public YOUR_TXT = 'Your changes have been saved!';
  public SUBMIT = "Submit"
  public SUBMIT_SMALL_TXT = 'submit'
  public ABOUT_TXT = 'About';
  public SUPPORTUS_TXT = 'Support us';
  public AUTHOR_WINDOW_TXT = "'s Window";
  public MEMBER_TXT = 'ALL-ACCESS MEMBER #';
  public MEMBER_TXT_1 = 'MEMBER #';
  public ROTATE_DEVICE_TXT = 'Please rotate your device to landscape mode';
  public WELCOME_TXT = 'Welcome';
  public BOOKMARKED_TXT = 'My Bookmarks';
  public MAPSEARCH_TXT = 'mapSearch';
  public BACK_TO_MAP_TXT = 'Back to Map';
  public USER_TXT = 'user'
  public TRUE_TXT = 'true'
  public MP4_TXT = '.mp4'
  public JPG_TXT = '.jpg'
  public UPDATE_VIDEO_COUNT = 500;
  public TAG_LIST = {
    animalsActive: false,
    rainActive: false,
    snowActive: false,
    natureActive: false,
    cityActive: false,
    nightActive: false,
    dayActive: false,
    interiorActive: false,
    waterActive: false
  }
  public MENU_ITEMS = {
    WINDOW_VIEWS : 'Window Views',
    SETTINGS : 'Settings',
    MY_WINDOW: 'My Windows',
    MYBOOKMARK: 'My Bookmarks',
    MY_TIPSJAR: 'My Tip-Jar',
    GET_ALL_ACCESS: 'Get All-Access',
    LOGOUT: 'Log out',
    SUBMIT_WINDOW: 'Submit Your Window'

  }
  public UNFIT_VIDEOS_TXT = 'unfitvideos';
  public UPLOADED_VIDEO_TXT = 'uploadedVideos';
  public DELETE_TXT = 'Delete';
  public UPLOAD_TXT = 'Upload';
  public SAVE_TXT = 'Save';
  public EDIT_DETAILS_TXT = 'Edit Details';
  public MY_BOOKMARK_WINDOW_HEADING = 'My Bookmarked Windows'
  public GET_WINDOWSWAP = 'Get WindowSwap All-Access'
  public BACK_TO_START = 'Or, go back to the start'
  public UNLOCK_WINDOW = 'Unlock all windows'
  public FAVOURIATE_WINDOW = 'your favourite windows.'
  public SIGNUP_TO_SAVE = 'Sign up to save'
  public SIGNUP_SHARE = 'Please sign up to share'
  public WINDOWVIEWS = '  your window views.'
  public WINDOW_VIEWS = 'Window Views'
  public VIEW_TXT = 'views'
  public IN_QUEUE_TXT = 'IN THE QUEUE'
  public UNBOOKMARKING = 'Or, make space by unbookmarking a few'
  public FEATURED_WINDOWS = ' for all windows ever featured'
  public EVER_FEATURED = 'ever featured.'
  public BACK_TO_ALLVIDEOS = 'Clear search'
  public CLOSE = 'close'
  public BOOKMARK_LIMIT = 'Oops! Bookmark limit reached.'
  public FACEBOOK_TXT = 'FACEBOOK';
  public WHATSAPP_SHARE_TXT = 'WHATSAPP';
  public TWITTER_TXT = 'TWITTER';
  public COPY_LINK_TXT = 'COPY LINK';
  public LINK_COPIED_TXT = 'LINK COPIED';
  public LINK_COPIED = 'COPIED'
  public GO_HOME = 'Go Home'
  public FAILED_VERIFICATION = 'Verification failled'
  public HEY_TXT = ' Hey ';
  public CONFIRM_TXT = 'Confirm';
  public TIPJAR_TXT = 'My Tip Jar';
  public JUNK_MAIL = 'please check your Junk Mail folder)'
  public JUNK_MAIL2 = "( If you can't find our mail in your Inbox, "
  public Total_Tips_TXT = 'Total Tips';
  public Number_OF_Tipers_TXT = 'Number of Tippers';
  public Number_tips_TXT = '$50.00';
  public Number_tipers_TXT = '15';
  public sending_TXT = 'sent you';
  public TERMS_CONDITIONS_TXT = "T&C's";
  public LOGIN_TXT = 'Login';
  public LOGIN_TXT_SIGNUP = 'Login here';
  public JOIN_TXT = 'Sign Up';
  public VERIFICATION_LINK = 'Please click the verification link sent to the email address you used to sign up with.'
  public FIRST_TIME_VERIFIED_TEXT ='Yay, you have been verified!';
  public FIRST_TIME_APP_VERIFIED_SUB_TEXT ='Continue to Window-Swap Gaze app to login';
  public FIRST_TIME_WEB_VERIFIED_SUB_TEXT ='Login below.';
  public ERROR_ALREADY_VERIFIED_TEXT = 'This email has already been verified.';
  public ERROR_ALREADY_VERIFIED_APP_SUB_TEXT = 'Continue to Window-Swap Gaze app to login';
  public ERROR_ALREADY_VERIFIED_WEB_SUB_TEXT = 'Please use it to login.';
  public ERROR_UNKNOWN_VERIFICATION_TEXT = 'Oops, there was an error verifying your email.';
  public ERROR_UNKNOWN_VERIFICATION_SUB_TEXT = 'Let us know at hello@window-swap.com.';
  public RESEND_CONFIRM = 'Resend Confirmation.'
  public LOG_OUT_TXT = 'Log Out';
  public QUESTION_MARK_TXT = '?';
  public SEND_US_VIEWS_TITLE_TXT = 'Send us your view!';
  public IMPORTANT_UPDATE_TITLE_TXT = 'Important Update';
  public WELCOME_BACK_TXT = 'Welcome back!';
  public LOGIN_WITH_FACEBOOK_TXT = 'Login with FB';
  public LOGIN_WITH_GOOGLE_TXT = 'Login with Google';
  public SIGN_UP_HEADING_TXT = 'Sign up to get the full WindowSwap experience';
  public SIGN_UP_HEADING_1_TXT = 'Sign up to submit your window view!';
  public SIGN_UP_SUB_HEADING_1_TXT = 'Share your window with the world.';
  public SIGN_UP_SUB_HEADING_2_TXT = 'See the number of views your windows get';
  public SIGN_UP_SUB_HEADING_3_TXT = 'Send and receive tips as thanks.';
  public SIGNUP_TO_SEE = ' Sign up to see this'
  public GOOGLEMAP_LOC = ' location on Google maps.'
  public SIGN_UP_SUB_HEADING_4_TXT =
    'Bookmark your favourite window views from around the world';
  public SIGN_UP_SUB_HEADING_1_1_TXT =
    'See the number of views your windows get';
  public SIGN_UP_SUB_HEADING_1_2_TXT =
    'Bookmark your favourite window views from around the world';
  public SIGN_UP_SUB_HEADING_1_3_TXT =
    'Be the first to know about our exciting updates';
  public SIGN_UP_SUB_HEADING_1_4_TXT = 'There’s so much more to come!';
  public STUCK_INDOOR_TXT = "Let's face it. We are all stuck indoors.";
  public TRAVEL_AGAIN_TXT =
    "And it's going to be a while till we travel again.";
  public FILL_THE_VOID_TXT =
    "Window Swap is here to fill that deep void in our wanderlust hearts by allowing us to look through someone else's window, somewhere in the world, for a while.";
  public PLACE_ON_INTERNET_TXT =
    "A place on the internet where all we travel hungry fools share our 'window views' to help each other feel a little bit better till we can (responsibly) explore our beautiful planet again.";
  public CONSIDER_SUPPORTING_US_AT_TXT =
    'Do consider supporting us at www.buymeacoffee.com/windowswap';
  public OR_SELECT_A_WINDOW_PLAYLIST_TXT = 'OR SELECT A WINDOW PLAYLIST'
  public ALL_WINDOW_VIEWS_TXT =
    'We need all the window views we can get. So, please send yours to';
  public QUNALIAA_EMAIL_TXT = 'qunaliaa@gmail.com';
  public SEND_US_VIDEO_INFORMATION_TXT =
    '  . Send us a 10-minute, horizontal HD video of your window and frame, with your first name and location for credits. It would be SUPER HELPFUL if you could rename your video file with your name and location before sending it to us. ';
  public NEW_VIDEO_UPDATES_TXT =
    'For updates on new video uploads, please follow us on instagram';
  public AT_WINDOW_SWAP_TXT = '@windowswap';
  public TRAVEL_WITHOUT_MOVING_TXT =
    "Let's travel without moving for now. Let's window swap.";
  public GOT_QUESTIONS_TXT = 'Got questions? Contact us at qunaliaa@gmail.com';

  public RECORD_TEN_MINUTE_TXT =
    '1. Record a 10 minute, horizontal HD video of your view with part of your window frame in the shot.';
  public WHILE_RECORDING_TXT =
    '2. Make sure not to shake or move while recording.';
  public RENAME_VIDEO_TXT =
    '3. Rename the video with your name and location for credits (if possible)';
  public MADE_IT_EASY_TXT =
    '4. We’ve now made it super-easy for you to submit your video! Just click the link below and follow the simple steps. :) ';
  public ABOUT_NOTE_TXT =
    "Note: Since we have thousands of submissions to go through, your view will take time to appear. We will email you once it's up.";
  public IMPORTANT_PRIVACY_TXT =
    'IMPORTANT: All videos have sound. To safeguard your privacy, only first names will be credited. ';
  public THANKS_FOR_SUPPORT_TXT =
    'Thanks for the overwhelming support. We are over the moon. But since it’s just two of us screening and uploading your videos, it may take a while before you see your beautiful window on the site.';

  public QUARANTINE_PROJECT_TXT =
    'Quarantine project by Sonali Ranjit and Vaishnav Balasubramaniam.';
  public SHOUTOUT_TXT =
    'Shoutout to Antara Aneja for her help, Maryam Touimi Benjelloun for the code, and to all our wonderful friends who sent us their views.';
  public SIGN_UP_FEATURE_1_TXT = "Oops! You'll have to";
  public SIGN_UP_FEATURE_2_TXT = 'sign up for this feature.';
  public SIGN_UP_FEATURE_DESCRIPTION_1_TXT = 'Signing up is simple and free.';
  public SIGN_UP_FEATURE_DESCRIPTION_2_TXT =
    'It will get you access to all our current';
  public SIGN_UP_FEATURE_DESCRIPTION_3_TXT =
    'and future features, help us grow WindowSwap';
  public SIGN_UP_FEATURE_DESCRIPTION_4_TXT = 'and keep it ad-free!';
  public SIGNUP_IS_SIMPLE_TXT =
    'Signing up is simple and free - letting you bookmark your favourite windows, submit your own and more.';
  public BOOKMARK_ALERT_TXT =
    'Upgrade to WindowSwap All-Access for unlimited bookmarks! ';
  public BOOKMARK_TXT = 'bookmarks'
  public BOOKMARK_UPGRADE = 'Upgrade to';
  public BOOKMARK_UPGRADE_NEW = 'Get WindowSwap All-Access';
  public BOOKMARK_UPGRADE_NEW_BOOKMARK_LMIT = 'for unlimited bookmarks, thousands of windows and more.';
  public WINDOWS_ALL_ACCESS = ' WindowSwap All-Access';
  public WINDOWSWAP_ALL_ACCESS_UPDATED = 'Upgrade to Windowswap All-Access for all windows ever featured,maps, and more.';
  public WINDOWSWAP_ALL_ACCESS_FEATURED = 'windows ever featured,maps, and more.'
  public FOR_SO_MUCH = 'for so much more!'

  public WINDOWS_ALL_ACCESS_NEW = 'for all windows ever featured and no ads';
  public SUBMIT_ALERT_TXT =
    'Signing up is simple and free. It will get you access to all our current and future features as we grow WindowSwap.';
  public BECOME_A_MEMBER_TXT =
    'With this upgrade, you will get access to our whole archive of thousands of unique window views from around the world plus unlimited bookmarks!';

  public WELCOME_POPUP_HEADING_BEFORE_TXT =
    'Welcome to the all-new WindowSwap experience!';
  public WELCOME_POPUP_HEADING_AFTER_1_TXT = 'Welcome to the';
  public WELCOME_POPUP_HEADING_AFTER_2_TXT = 'WindowSwap community!';
  public SIGNUP_FOR_FREE_TXT = 'Sign up for free';
  public GET_STARTED_TXT = 'Get Started';
  public FOLKS = '  That’s all for this week, folks!'
  public LOADING_TEXT = 'Loading...'
  public SAY_THANKS = 'Say Thanks'
  public YES = 'Yes'
  public NO = 'No'
  public CANCEL = 'Cancel'

  public COMING_SOON_TXT = 'The world would love to see your view!';
  public YOU_WILL_SOON_TXT = ' Windows you upload will appear here, and you’ll';
  public ON_THE_WINDOW_TXT =
    'be able to see stats on how many people have gazed out of it.';

  public WELCOME_POPUP_CONTENT_BEFORE_TXT = 'All-new features!';
  public WELCOME_POPUP_CONTENT_1_BEFORE_TXT = 'Easier way to submit windows';
  public WELCOME_POPUP_CONTENT_2_BEFORE_TXT =
    'See the number of views on your windows';
  public WELCOME_POPUP_CONTENT_3_BEFORE_TXT =
    'Bookmark your favourites windows';
  public WELCOME_POPUP_CONTENT_4_BEFORE_TXT =
    'Create and manage your own profile';

  public ALL_THE_VIDEOS_TXT = 'All the videos you save will appear here';
  public HIT_THE_TXT = 'Hit the';
  public BUTTON_TO_TXT = 'button to save a window you like';

  public DECLINE_REASON_1_TXT = 'The video is too short';
  public DECLINE_REASON_2_TXT = 'Vertical video';
  public DECLINE_REASON_3_TXT = 'Bad video quality';
  public DECLINE_REASON_4_TXT = 'Too much movement';
  public DECLINE_REASON_5_TXT = 'Face seen in frame';
  public DECLINE_REASON_6_TXT = 'Not a window view ';
  public DECLINE_REASON_7_TXT = 'Nudity/ offensive language or content';
  public DECLINE_REASON_HEADING_TXT = 'Why are we declining this video?';
  public WINDOW_QUEUE_TXT = 'The Window Queue';
  public WINDOW_APPROVED_TXT = 'Approved Windows';
  public WINDOW_DECLINED_TXT = 'Declined Videos';
  public WINDOW_UPLOADED_TXT = 'Uploaded Videos';
  public CURATED_VIDEO_TXT ='Curated Videos';
  public NON_CURATED_VIDEOS_TEXT = 'All Videos';
  public CURATE_SELECTED_TXT = 'Curate';
  public UNCURATE_SELECTED_TXT = 'Uncurate';
  public TOGGLE_FREE_VIDEO_TXT = 'Toggle free';
  public TP_VIMEO_TOKEN_TXT = 'TP_VIMEO_TOKEN'
  public EDIT_TXT = 'Edit details';
  public CANCEL_TXT = 'Cancel';
  public DONE_TXT = 'Done';
  public PENDING_TXT = 'pending';
  public APPROVED_TXT = 'approved';
  public FAILED_TXT = 'failed';
  public REJECTED_TXT = 'rejected';
  public UPLOADEDTOVIEO_TXT = 'uploadedToVimeo';
  public REJECTION_IN_PROGRES = "rejection_in_progress";
  public STATUS_TXT = {
    PENDING_TXT: this.PENDING_TXT,
    APPROVED_TXT: this.APPROVED_TXT,
    REJECTED_TXT: this.REJECTED_TXT,
    UPLOADEDTOVIEO_TXT: this.UPLOADEDTOVIEO_TXT,
    SUCCESS: "success"
  };
  public WINDOW_UPLOADED_TO_VIMEO_TXT =
    'this window is successfully uploaded to Vimeo';
  public ADMIN_TXT = 'admin';
  public ADMIN_CAP_TXT = 'Admin';
  public GET_LIST = 'getVideoList';
  public NOT_ASSIGNED_TXT = 'Not assigned';
  public UPLOADED_TXT = 'uploaded';
  public CURATED_TXT ='curated';
  public GDRIVE_TXT = 'gdrive';
  public SELECT_VIDEO_TXT = 'Please select a Video';
  public SELECT_10_VIDEO_TXT = 'Please select maximum 10 videos';
  public THIS_IS_IN_PENDING_TXT = 'This video is in pending stage';
  public BLOCK_TXT = 'block';
  public NONE_TXT = 'none';
  public WINDOW_UPLOAD_TXT = 'Window Uploaded to vimeo Successfully';
  public COULD_NOT_UPLOAD_TXT = "Couldn't upload !! Something went srong";
  public ERROR_TXT = "Something went srong !!";
  public SUBMIT_TXT = 'Submit';
  public SMALL_SUBMIT_TXT = 'submit';
  public ANOTHER_WINDOW = ' Open another window'
  public WINDOWSWAP_MUSIC = 'The WindowSwap Music Video'
  public GLOBAL_COLLAB = 'is out! Click to enjoy this global collab.'
  public THIS_KEEPS = 'This ad helps keep WindowSwap free.'
  public REMOVE_AD = 'Remove Ads'
  public CONTINUE = 'Continue'
  public CURATION_TIMEOUT_ERROR_TXT = 'Curation process timed out';
  public CURATION_COMPLETED = 'Curation completed';
  public TIMEOUT_ERROR_TXT = environment.production ? 'Http failure response for https://dybnyx8r1i.execute-api.us-east-1.amazonaws.com/prod/update/submit: 0 Unknown Error' : 'Http failure response for https://x45lddhmu1.execute-api.us-east-1.amazonaws.com/dev/update/submit: 0 Unknown Error'
  public REJECT_REASON_1_TXT =
    'Video too short: Your video should be at least 5 minutes long';
  public DELETED_TXT = 'Videos Deleted successfully';
  public DELETED_TXT_SINGLE = 'Video Deleted successfully';
  public GOOGLE_API_ERROR_TXT = 'As per google api policy max 3 selections are available';
  public REJECT_REASON_2_TXT =
    'Vertical video: Your video has to be shot horizontally';
  public REJECT_REASON_3_TXT =
    'Low video quality: Please shoot your video in HD';
  public REJECT_REASON_4_TXT =
    'Video too shaky: Try not to shake your camera/phone or move it around when you shoot';
  public REJECT_REASON_5_TXT =
    'Face seen in frame: WindowSwap is only for your window views';
  public REJECT_REASON_6_TXT =
    'Not a window view:  Please make sure there is a window frame in the shot';
  public REJECT_REASON_7_TXT =
    'Nudity/ offensive language or content: Nobody likes this';
  public VIDEO_APPROVED_TXT = 'Video approved successfully';
  public VIDEO_COMMON_KEY = '101010';

  public YOUR_WINDOW_TXT = 'Your window is in the queue.';
  public WE_UPLOAD_TXT =
    'We upload 200 videos everyweek, and we have thousands of submissions to go through.';
  public YOUR_MIGHT_TXT =
    'So, yours might take some time to show up. Please bear with us. We will email you when it is up on the site!';

  public HOW_TO_TXT = 'Share 10 minutes of your window view';
  public HOW_TO_CONTENT_1_TXT =
    'Record a 10 minute, horizontal, HD video of your view.';
  public HOW_TO_CONTENT_2_TXT =
    'Make sure to capture at least part of your window or balcony door frame in the shot.';
  public HOW_TO_CONTENT_3_TXT =
    'Keep your camera or phone steady. Please do not shake or move about while recording!';

  public PRIME_TITLE_TXT =
    'WindowSwap All-Access was created to keep WindowSwap alive';
  public PRIME_TITLE_TXT_1 =
    'Apart from helping us keep the power on, here’s what you get';
  public PRIME_TITLE_TXT_2 =
    'A big thanks and hug from us to you wherever you are!';
  public PRIME_TITLE_TXT_3 = 'Sonali and Vai';
  public PRIME_TITLE_TXT_4 = 'Reviews manually.cancel anytime';
  public CHOOSE_FROM = 'A whole world of calming windows to choose from.';
  public MONTHLY_SUBSCRIPTION = 'Upgrade for $5 monthly';
  public MONTHLY_SUBSCRIPTION_NEW = 'Unlock for $5 monthly';
  public GET_ALL_ACCESS = 'Get WindowSwap All-Access';
  public GET_ALL_ACCESS_SUB = 'and search through thousands of windows by location.';
  public AFTER_5_10_VIDEOS_TEXT1 = 'Upgrade for a new world ';
  public AFTER_5_10_VIDEOS_TEXT2 = 'of calming windows ';
  public AFTER_5_10_VIDEOS_TEXT3 = 'and helpful features.';
  public PAY_20_TXT = "Pay USD 20 Annually";
  public PAY_50_TXT = "Pay USD 50 Annually";
  public PAY_5_TXT = "Pay USD 5 Monthly";
  public CLOSE_PAGE_TXT = "Get Started!";
  public WELCOME_TO_TXT = "Welcome to ";
  public WINDOWSWAP_ALL_TXT = "WindowSwap All-Access!";
  public THANK_TXT = "Thank you so much for your support- Sonali and Vai";
  public PRIME_PAYMENT_SUCCESS_TXT = 'A world of calming new windows awaits - along with the freedom to search, filter and go back to that amazing window you skipped by mistake :)'
  public UNIQUE_WORLD = 'A unique world of calm.';
  public OPEN_A_WORLD_TXT = 'Open a new world';
  public CLAIMING_TXT = 'of calming windows ';
  public UNSUBSCRIBE_TXT = 'Unsubscribe';
  public HELPING_FEATURE_TXT = 'and helpful features.';
  public GET_ALL_ACCESS_TXT = 'Get WindowSwap All-Access';
  public GET_ALL_ACCESS_TXT_PRICING = 'Get WindowSwap All-Access for';
  public PRICING_TXT = '$5 a month or $50 a year.';
  public PRICING_TXT_20 = '$5 a month or $20 a year.';
  public PRICE_RATES = {
    MONTHLY_RATE: 5,
    YEARLY_RATE1: 20,
    YEARLY_RATE2: 50
  }
  public PLAN_TYPE = {
    YEARLY: "annually",
    MONTHLY: "monthly"
  }
  public UPGRADE_TXT_BTN = 'Upgrade to All-Access';
  public FREE_MEMBER_TXT = 'FREE MEMBER'
  public FREE_TXT = 'Free'
  public FOREVER_TXT = 'FOREVER'
  public FIVE_MONTH_TXT = '$5/month'
  public OR_FIFTY_ANUALLY_TXT = 'or $50 annually'
  public OR_FIFTY_ANUALLY_TXT_20 = 'or $20 annually'
  public A_NEW_WAY_TXT = 'A new way to explore incredible views from around the world.'
  public NOW_YOU_TXT = 'Now, you can use a map or a searchbar to find relaxing new views from different countries.'
  public THOUSANDS_CLAMIN_TXT = 'Thousands of calming views at your discretion'
  public ACCESS_OUR_TXT = 'Access our entire archive of windows ever uploaded'
  public WHAT_BRING_TXT = 'What brings you peace?'
  public A_SNOW_DAYS_TXT = 'A snowy day? Furry pets lounging around?'
  public OR_JUST_TXT = 'Or just the never ending sound of rain?'
  public GET_JUST = 'Get just the type of windows you want with WindowSwap Playlists.'
  public PLUST_A_TXT = 'Plus a host of other great features'
  public UNLIMITED_BKMRK_TXT = 'Unlimited bookmarks'
  public ACCESS_TO_TXT = 'Access to '
  public A_BACK_TXT = 'a back button!'
  public MORE_TXT = 'More features'
  public COMING_TXT = 'coming soon!';
  public CONFIRM_DELETE_BOOKMARK_TEXT = 'Sure you want';
  public CONFIRM_DELETE_BOOKMARK_TEXT_1 = 'to remove this window';
  public CONFIRM_DELETE_BOOKMARK_TEXT_2 = 'from your bookmarks?';
  public UPGRADE_FOR_PLAYLIST = 'Upgrade for playlists';
  public UPGRADE_FOR_PLAYLIST_1 = 'that suit your mood.';
  public UPGRADE_FOR_PLAYLIST_2 = 'In the mood for pets? Or endless streams of rainy views? Filter our entire archive by type with WindowSwap Playlists.';
  public GET_ALL_ACCESS_NOTMENU = 'Get All-Access';
  public ENTIRE_AMOUNT_YOURS = 'The entire Tip amount is now yours.';
  public ENTIRE_AMOUNT_YOURS_10PERCENT_INTREST = 'From September 2022, we will no longer charge 10% of your Tip amount.';
  public ENTIRE_AMOUNT_YOURS_TIPJAR_THANKS = 'Thanks for sharing your view!';
  public ALREADY_TEXT_VERIFY = 'There is already a';
  public ALREADY_TEXT_VERIFY_1 = 'WindoSwap account linked';
  public ALREADY_TEXT_VERIFY_2 = 'to this email.';
  public ALREADY_TEXT_VERIFY_3 = 'Please use it to log in';
  public META_TAG_FOR_HOME = 'Open a new window somewhere in the world. Look through windows shared by real people, and share yours to become a part of this global community.';


  public INTERIOR_PLAYLIST = 'Entering the ‘Interior’ playlist...'
  public CITY_PLAYLIST = 'Entering the ‘City’ playlist...'
  public PETS_PLAYLIST = 'Entering the ‘Animals’ playlist...'
  public NIGHT_PLAYLIST = 'Entering the ‘Night’ playlist...'
  public SNOW_PLAYLIST = 'Entering the ‘Snow’ playlist...'
  public RAIN_PLAYLIST = 'Entering the ‘Rain’ playlist...'
  public NATURE_PLAYLIST = 'Entering the ‘Nature’ playlist...'
  public WATER_PLAYLIST = 'Entering the Water playlist...'
  public BACK_TO_ALLWINDOW = 'Back to all the windows '
  public ADMIN_NAV_ITEM_0 = 'Gdrive uploads';
  public ADMIN_NAV_ITEM_1 = 'Window Queue';
  public ADMIN_NAV_ITEM_2 = 'Approved Windows';
  public ADMIN_NAV_ITEM_3 = 'Declined Videos';
  public ADMIN_NAV_ITEM_4 = 'Uploaded Videos';
  public ADMIN_NAV_ITEM_5 = 'Failed Videos';
  public ADMIN_NAV_ITEM_6 = 'Curated Videos';
  public CREATE_TXT = 'Create .txt file';
  public SELECT_TXT = 'Select All';
  public LIVE_VIDEO_TXT = 'Live Videos';
  public UPLOADTOVIMEO_TXT = 'Upload to Vimeo';
  public ANIMALS_TXT = 'Animals';
  public RAIN_TXT = 'Rain';
  public SNOW_TXT = 'Snow';
  public CITY_TXT = 'City';
  public NATURE_TXT = 'Nature';
  public NIGHT_TXT = 'Night';
  public WATER_TXT = 'Water';
  public DAY_TXT = 'Day';
  public DEFAULT_TAGS = [
    { name: 'Animals', status: false },
    { name: 'Rain', status: false },
    { name: 'Snow', status: false },
    { name: 'City', status: false },
    { name: 'Nature', status: false },
    { name: 'Night', status: false },
    { name: 'Day', status: false },
    { name: 'Interior', status: false },
    { name: 'Water', status: false },
  ]
  public NICKNAME_TXT = 'Display Name'
  public RECORDED_DATE_AND_TIME_TXT = 'Recorded Date and Time'
  public INTERIORS_TXT = 'Interior';
  public LOCATION_TXT = 'Location'
  public COUNTRY_TXT = 'Country'
  public RECORDING_TIME_TXT = 'Time of Recording'
  public RECORDING_DATE_TXT = 'Date of Recording'
  public SELECT_COUNTRY_TXT = 'Select Country'
  public TAG_WINDOW_TXT = 'Tag your window!'
  public COLLAB_PARA_TXT = 'Would you like your video to be a part of Brand or Artist collaborations?You will earn a share of the revenue we earn!'
  public I_ACCEPT_TXT = 'I accept the'
  public TANDC_TXT = 'terms and conditions'
  public SUBMIT_THANK_1_TXT = 'WindowSwap wouldn’t be what it is without'
  public SUBMIT_THANK_2_TXT = 'your wonderful window views.'
  public SUBMIT_THANK_PARA_1_TXT = 'We will review your video and add it to the queue.'
  public SUBMIT_THANK_PARA_2_TXT = 'You will be notified when it goes up!'
  public SUBMIT_THANK_PARA_3_TXT = 'Thank you for your patience.'
  public CRETOR_THANK_1_TXT = 'You’re on a roll! Thank you'
  public CRETOR_THANK_2_TXT = 'for another gorgeous view.'
  public CRETOR_THANK_PARA1_TXT = 'We will review your video and add it to the queue.'
  public CRETOR_THANK_PARA2_TXT = 'You will be notified when it goes up.'
  public CRETOR_THANK_PARA3_TXT = 'We will review your video and add it to the queue. You will be notified when it goes up.'
  public CRETOR_THANK_PARA4_TXT = 'Thanks again for your awesomeness!'
  public VIEW_PROF_BUTTON_TXT = 'View your profile'
  public TAKE_SURVEY = 'Take our survey!'
  public GIFT_ALL_ACCESS = 'Gift WindowSwap All-Access'
  public PREV_TXT = 'prev';
  public NEXT_TXT = 'next';
  public THE_TIPS_JAR = 'The Tip Jar'
  public UPGRADE_5_TXT = 'Upgrade for $5 monthly'
  public UPGRADE_NOW_TXT = 'Upgrade now for $5 monthly'
  public ALL_ACCESS_MEMBER_TXT = 'All-Access Member'
  public ACCEPT_TXT = 'Accept';
  public DECLINE_TXT = 'Decline';
  public COPY_TXT = 'copy mail';
  public SURVEY_PARA = 'Help us make WindowSwap better.'
  public GIFT_PARA = 'A gift of calm for someone you love'
  public SEND_TIPS_TXT = 'Send someone a tip as thanks for sharing a window view - or receive tips from someone who loved yours'
  public FIND_OUT_HOW_TXT = 'Find out how'
  public ALLESSIO_TXT = 'Alessio - Tellaro, Italy'
  public WINDOWSWAP_ARTISTS_TXT = 'WINDOWSWAP ARTISTS'
  public TAG_GROUP = { INTERIOR: 'INTERIOR', NATURE: 'NATURE', CITY: 'CITY', NIGHT: 'NIGHT', DAY: 'DAY', RAIN: 'RAIN', SNOW: 'SNOW', PETS: 'ANIMALS', WATER: 'WATER' };
  public NO_WINDOW = 'Oops! No windows to open here yet.';
  public TRY_OTHER = 'Try a different country?';
  public OPEN_WINDOW_IN = 'Open a window in ';
  public IF_YOU_TXT = 'If you happen to know someone here,';
  public PLEASE_ASK_TXT = 'please ask them to share their window!';
  public OOPS_NO_WINDOW_TXT = 'Oops! No windows there yet, taking you to the closest window';
  public COUNTRY_USA = 'USA';
  public COUNTRY_USA_1 = 'UNITED STATES';
  public COUNTRY_USA_2 = 'UNITED STATES OF AMERICA';
  public COUNTRY_UAE = 'UAE';
  public COUNTRY_UAE_1 = 'UNITED ARAB EMIRATES';
  public COUNTRY_UK = 'UK';
  public COUNTRY_UK_1 = 'UNITED KINGDOM';
  public QUERY_TXT = 'Issues or questions ? Email us at';
  public MAX_SIZE_NUM = 5368700000
  public DRAG_AND_DROP_TXT = 'Drag and drop your file here';
  public HIT_PLUS = 'hit ‘+’ to upload your video';
  public HIT_PLUS_MOB = 'Add your window here';
  public ONLY_UPLOAD = 'Only upload videos you own the rights to';
  public RESPECT_TXT = 'Respect the intellectual property of others';
  public ZERO_TOLL_TXT = 'Zero tolerance for nudity, violence or hate.'
  public READY_FOR_TXT = 'Your window is ready '
  public TO_BE_UPLOADED = 'to be uploaded.'
  public PLEASE_START_TXT = 'Please start adding your details for credits '
  public HIT_UPLOAD = 'and then hit upload!'
  public PLEASE_ADD_TXT = 'Please add your details for credits.'
  public USER_CONFIRM_ERROR = {
    CODE: "NotAuthorizedException",
    MESSAGE: "User cannot be confirmed. Current status is CONFIRMED"
  }
  public REPORT_COPIED = "Error report copied! Please email it to us.";
  public DEFAULT_MAP_CENTRE = { lat: 54.525961, lng: 15.255119 };
  public SRIPE_CARD_STYLE = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#265D6E',
        fontWeight: '400',
        fontFamily: 'Graphik',
        fontSize: '12px',
        '::placeholder': {
          color: '#CFD7E0',
        },
      },
    },
  };
  public SRIPE_CARD_STYLE_GIFT = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#265D6E',
        fontWeight: '400',
        fontFamily: 'sans-serif',
        fontSize: '16px',
        '::placeholder': {
          color: '#265D6E',
        },
      },
    },
  };
  public PRIME_BENEFITS = [
    {
      title: 'Ad free!',
      titleMob: 'Ad free!',
      free: '',
      paid: 'img'
    },
    {
      title: 'A ‘Back’ button to view the previous window',
      titleMob: 'A ‘Back’ button',
      free: '',
      paid: 'img'
    },
    {
      title: 'Filter windows by kind (e.g. snowy windows)',
      titleMob: 'Filter windows by kind ',
      free: '',
      paid: 'img'
    },
    {
      title: 'Search windows by location',
      titleMob: 'Search windows by location',
      free: '',
      paid: 'img'
    },
    {
      title: 'Submit your Window View',
      titleMob: 'Submit your Window View',
      free: 'img',
      paid: 'img'
    },
    {
      title: 'Earn tips for your windows',
      titleMob: 'Earn tips for your windows',
      free: 'img',
      paid: 'img'
    },
    {
      title: 'Windows Available',
      titleMob: 'Windows Available',
      free: '250 windows a week',
      paid: 'All windows ever uploaded'
    },
    {
      title: 'Bookmark windows',
      titleMob: 'Bookmark windows',
      free: '30 bookmarks',
      paid: 'Unlimited Bookmarks'
    }
  ]
  public PLAYLIST = [
    {
      tagValue: 'Interiors',
      tagImgSrc: this.INTERIOR_IMG,
      tagText: this.TAG_GROUP.INTERIOR
    },
    {
      tagValue: 'City',
      tagImgSrc: this.CITY_IMG,
      tagText: this.TAG_GROUP.CITY
    },
    {
      tagValue: 'Nature',
      tagImgSrc: this.NATURE_IMG,
      tagText: this.TAG_GROUP.NATURE
    },
    {
      tagValue: 'Rain',
      tagImgSrc: this.RAIN_IMG,
      tagText: this.TAG_GROUP.RAIN
    },
    {
      tagValue: 'Animals',
      tagImgSrc: this.PETS_IMG,
      tagText: this.TAG_GROUP.PETS
    },
    {
      tagValue: 'Snow',
      tagImgSrc: this.SNOW_IMG,
      tagText: this.TAG_GROUP.SNOW
    },
    {
      tagValue: 'Night',
      tagImgSrc: this.NIGHT_IMG,
      tagText: this.TAG_GROUP.NIGHT
    },
    {
      tagValue: 'Water',
      tagImgSrc: this.WATER_IMG,
      tagText: this.TAG_GROUP.WATER
    },
  ]
  public GOOGLE_DRIVE_API_IFRAME_URL = 'https://drive.google.com/file/d/';
  public GCP_URL = 'https://lh3.googleusercontent.com/d/';
  public GOOGLE_DRIVE_API = 'https://www.googleapis.com/drive/v3/files/';
  public MONTHS_LIST = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  public TITLE = {
    submit: 'WindowSwap - Submit your Window',
    home: 'WindowSwap - Watch windows around the world',
    bookmark: 'Bookmarked Windows',
    window: 'Playing Windows from'
  }

  public COUNTRY_LIST_TXT = [
    {
      countryName: 'Afghanistan',
      countryCode: 'AF',
    },
    {
      countryName: 'Albania',
      countryCode: 'AL',
    },
    {
      countryName: 'Algeria',
      countryCode: 'DZ',
    },
    {
      countryName: 'Andorra',
      countryCode: 'AD',
    },
    {
      countryName: 'Angola',
      countryCode: 'AO',
    },
    {
      countryName: 'Antigua and Barbuda',
      countryCode: 'AG',
    },
    {
      countryName: 'Argentina',
      countryCode: 'AR',
    },
    {
      countryName: 'Armenia',
      countryCode: 'AM',
    },
    {
      countryName: 'Australia',
      countryCode: 'AU',
    },
    {
      countryName: 'Austria',
      countryCode: 'AT',
    },
    {
      countryName: 'Azerbaijan',
      countryCode: 'AZ',
    },
    {
      countryName: 'Bahamas',
      countryCode: 'BS',
    },
    {
      countryName: 'Bahrain',
      countryCode: 'BH',
    },
    {
      countryName: 'Bangladesh',
      countryCode: 'BD',
    },
    {
      countryName: 'Barbados',
      countryCode: 'BB',
    },
    {
      countryName: 'Belarus',
      countryCode: 'BY',
    },
    {
      countryName: 'Belgium',
      countryCode: 'BE',
    },
    {
      countryName: 'Belize',
      countryCode: 'BZ',
    },
    {
      countryName: 'Benin',
      countryCode: 'BJ',
    },
    {
      countryName: 'Bermuda',
      countryCode: 'BM',
    },
    {
      countryName: 'Bhutan',
      countryCode: 'BT',
    },
    {
      countryName: 'Bolivia',
      countryCode: 'BO',
    },
    {
      countryName: 'Bosnia and Herzegovina',
      countryCode: 'BA',
    },
    {
      countryName: 'Botswana',
      countryCode: 'BW',
    },
    {
      countryName: 'Brazil',
      countryCode: 'BR',
    },
    {
      countryName: 'Brunei',
      countryCode: 'BN',
    },
    {
      countryName: 'Bulgaria',
      countryCode: 'BG',
    },
    {
      countryName: 'Burkina Faso',
      countryCode: 'BF',
    },
    {
      countryName: 'Burundi',
      countryCode: 'BI',
    },
    {
      countryName: 'Cabo Verde',
      countryCode: 'CV',
    },
    {
      countryName: 'Cambodia',
      countryCode: 'KH',
    },
    {
      countryName: 'Cameroon',
      countryCode: 'CM',
    },
    {
      countryName: 'Canada',
      countryCode: 'CA',
    },
    {
      countryName: 'CAR',
      countryCode: 'CF',
    },
    {
      countryName: 'Chad',
      countryCode: 'TD',
    },
    {
      countryName: 'Chile',
      countryCode: 'CL',
    },
    {
      countryName: 'China',
      countryCode: 'CN',
    },
    {
      countryName: 'Colombia',
      countryCode: 'CO',
    },
    {
      countryName: 'Comoros',
      countryCode: 'KM',
    },
    {
      countryName: 'Congo, Democratic',
      countryCode: 'CD',
    },
    {
      countryName: 'Congo, Republic',
      countryCode: 'CG',
    },
    {
      countryName: 'Costa Rica',
      countryCode: 'CR',
    },
    {
      countryName: "Cote d'Ivoire",
      countryCode: 'CI',
    },
    {
      countryName: 'Croatia',
      countryCode: 'HR',
    },
    {
      countryName: 'Cuba',
      countryCode: 'CU',
    },
    {
      countryName: 'Cyprus',
      countryCode: 'CY',
    },
    {
      countryName: 'Czechia',
      countryCode: 'CZ',
    },
    {
      countryName: 'Denmark',
      countryCode: 'DK',
    },
    {
      countryName: 'Djibouti',
      countryCode: 'DJ',
    },
    {
      countryName: 'Dominica',
      countryCode: 'DM',
    },
    {
      countryName: 'Dominican Republic',
      countryCode: 'DO',
    },
    {
      countryName: 'Ecuador',
      countryCode: 'EC',
    },
    {
      countryName: 'Egypt',
      countryCode: 'EG',
    },
    {
      countryName: 'El Salvador',
      countryCode: 'SV',
    },
    {
      countryName: 'Equatorial Guinea',
      countryCode: 'GQ',
    },
    {
      countryName: 'Eritrea',
      countryCode: 'ER',
    },
    {
      countryName: 'Estonia',
      countryCode: 'EE',
    },
    {
      countryName: 'Eswatini',
      countryCode: 'SZ',
    },
    {
      countryName: 'Ethiopia',
      countryCode: 'ET',
    },
    {
      countryName: 'Fiji',
      countryCode: 'FJ',
    },
    {
      countryName: 'Finland',
      countryCode: 'FI',
    },
    {
      countryName: 'France',
      countryCode: 'FR',
    },
    {
      countryName: 'Gabon',
      countryCode: 'GA',
    },
    {
      countryName: 'Gambia',
      countryCode: 'GM',
    },
    {
      countryName: 'Georgia',
      countryCode: 'GE',
    },
    {
      countryName: 'Germany',
      countryCode: 'DE',
    },
    {
      countryName: 'Ghana',
      countryCode: 'GH',
    },
    {
      countryName: 'Greece',
      countryCode: 'GR',
    },
    {
      countryName: 'Grenada',
      countryCode: 'GD',
    },
    {
      countryName: 'Guatemala',
      countryCode: 'GT',
    },
    {
      countryName: 'Guinea',
      countryCode: 'GN',
    },
    {
      countryName: 'Guinea - Bissau',
      countryCode: 'GW',
    },
    {
      countryName: 'Guyana',
      countryCode: 'GY',
    },

    {
      countryName: 'Haiti',
      countryCode: 'HT',
    },
    {
      countryName: 'Honduras',
      countryCode: 'HN',
    },
    {
      countryName: 'Hungary',
      countryCode: 'HU',
    },
    {
      countryName: 'Iceland',
      countryCode: 'IS',
    },
    {
      countryName: 'India',
      countryCode: 'IN',
    },
    {
      countryName: 'Indonesia',
      countryCode: 'ID',
    },
    {
      countryName: 'Iran',
      countryCode: 'IR',
    },
    {
      countryName: 'Iraq',
      countryCode: 'IQ',
    },
    {
      countryName: 'Ireland',
      countryCode: 'IE',
    },
    {
      countryName: 'Israel',
      countryCode: 'IL',
    },

    {
      countryName: 'Italy',
      countryCode: 'IT',
    },
    {
      countryName: 'Jamaica',
      countryCode: 'JM',
    },
    {
      countryName: 'Japan',
      countryCode: 'JP',
    },
    {
      countryName: 'Jordan',
      countryCode: 'JO',
    },

    {
      countryName: 'Kazakhstan',
      countryCode: 'KZ',
    },
    {
      countryName: 'Kenya',
      countryCode: 'KE',
    },
    {
      countryName: 'Kiribati',
      countryCode: 'KI',
    },
    {
      countryName: 'Kosovo',
      countryCode: 'XK',
    },
    {
      countryName: 'Kuwait',
      countryCode: 'KW',
    },
    {
      countryName: 'Kyrgyzstan',
      countryCode: 'KG',
    },
    {
      countryName: 'Laos',
      countryCode: 'LA',
    },
    {
      countryName: 'Latvia',
      countryCode: 'LV',
    },
    {
      countryName: 'Lebanon',
      countryCode: 'LB',
    },
    {
      countryName: 'Lesotho',
      countryCode: 'LS',
    },
    {
      countryName: 'Liberia',
      countryCode: 'LR',
    },
    {
      countryName: 'Libya',
      countryCode: 'LY',
    },
    {
      countryName: 'Liechtenstein',
      countryCode: 'LI',
    },
    {
      countryName: 'Lithuania',
      countryCode: 'LT',
    },
    {
      countryName: 'Luxembourg',
      countryCode: 'LU',
    },
    {
      countryName: 'Madagascar',
      countryCode: 'MG',
    },

    {
      countryName: 'Malaysia',
      countryCode: 'MY',
    },
    {
      countryName: 'Maldives',
      countryCode: 'MV',
    },
    {
      countryName: 'Mali',
      countryCode: 'ML',
    },
    {
      countryName: 'Malta',
      countryCode: 'MT',
    },
    {
      countryName: 'Marshall Islands',
      countryCode: 'MH',
    },
    {
      countryName: 'Mauritania',
      countryCode: 'MR',
    },
    {
      countryName: 'Mauritius',
      countryCode: 'MU',
    },
    {
      countryName: 'Mexico',
      countryCode: 'MX',
    },
    {
      countryName: 'Micronesia',
      countryCode: 'FM',
    },
    {
      countryName: 'Moldova',
      countryCode: 'MD',
    },
    {
      countryName: 'Monaco',
      countryCode: 'MC',
    },
    {
      countryName: 'Mongolia',
      countryCode: 'MN',
    },
    {
      countryName: 'Montenegro',
      countryCode: 'ME',
    },
    {
      countryName: 'Morocco',
      countryCode: 'MA',
    },
    {
      countryName: 'Mozambique',
      countryCode: 'MZ',
    },
    {
      countryName: 'Myanmar',
      countryCode: 'MM',
    },
    {
      countryName: 'Namibia',
      countryCode: 'NA',
    },
    {
      countryName: 'Nauru',
      countryCode: 'NR',
    },
    {
      countryName: 'Nepal',
      countryCode: 'NP',
    },
    {
      countryName: 'Netherlands',
      countryCode: 'NL',
    },
    {
      countryName: 'New Zealand',
      countryCode: 'NZ',
    },
    {
      countryName: 'Nicaragua',
      countryCode: 'NI',
    },
    {
      countryName: 'Niger',
      countryCode: 'NE',
    },
    {
      countryName: 'Nigeria',
      countryCode: 'NG',
    },
    {
      countryName: 'North Korea',
      countryCode: 'KP',
    },
    {
      countryName: 'North Macedonia',
      countryCode: 'MK',
    },
    {
      countryName: 'Norway',
      countryCode: 'NO',
    },
    {
      countryName: 'Oman',
      countryCode: 'OM',
    },
    {
      countryName: 'Pakistan',
      countryCode: 'PK',
    },
    {
      countryName: 'Palau',
      countryCode: 'PW',
    },
    {
      countryName: 'Palestine',
      countryCode: 'PS',
    },
    {
      countryName: 'Panama',
      countryCode: 'PA',
    },
    {
      countryName: 'Papua New Guinea',
      countryCode: 'PG',
    },
    {
      countryName: 'Paraguay',
      countryCode: 'PY',
    },
    {
      countryName: 'Peru',
      countryCode: 'PE',
    },
    {
      countryName: 'Philippines',
      countryCode: 'PH',
    },
    {
      countryName: 'Poland',
      countryCode: 'PL',
    },
    {
      countryName: 'Portugal',
      countryCode: 'PT',
    },
    {
      countryName: 'Qatar',
      countryCode: 'QA',
    },
    {
      countryName: 'Romania',
      countryCode: 'RO',
    },
    {
      countryName: 'Russia',
      countryCode: 'RU',
    },
    {
      countryName: 'Rwanda',
      countryCode: 'RW',
    },
    {
      countryName: 'Saint Kitts and Nevis',
      countryCode: 'KN',
    },
    {
      countryName: 'Saint Lucia',
      countryCode: 'LC',
    },
    {
      countryName: 'Saint Vincent and the Grenadines',
      countryCode: 'VC',
    },

    {
      countryName: 'Samoa',
      countryCode: 'WS',
    },
    {
      countryName: 'San Marino',
      countryCode: 'SM',
    },
    {
      countryName: 'Sao Tome and Principe',
      countryCode: 'ST',
    },
    {
      countryName: 'Saudi Arabia',
      countryCode: 'SA',
    },
    {
      countryName: 'Senegal',
      countryCode: 'SN',
    },
    {
      countryName: 'Serbia',
      countryCode: 'RS',
    },
    {
      countryName: 'Seychelles',
      countryCode: 'SC',
    },
    {
      countryName: 'Sierra Leone',
      countryCode: 'SL',
    },
    {
      countryName: 'Singapore',
      countryCode: 'SG',
    },
    {
      countryName: 'Slovakia',
      countryCode: 'SK',
    },
    {
      countryName: 'Slovenia',
      countryCode: 'SI',
    },
    {
      countryName: 'Solomon Islands',
      countryCode: 'SB',
    },
    {
      countryName: 'Somalia',
      countryCode: 'SO',
    },
    {
      countryName: 'South Africa',
      countryCode: 'ZA',
    },
    {
      countryName: 'South Korea',
      countryCode: 'KR',
    },
    {
      countryName: 'South Sudan',
      countryCode: 'SS',
    },
    {
      countryName: 'Spain',
      countryCode: 'ES',
    },
    {
      countryName: 'Sri Lanka',
      countryCode: 'LK',
    },
    {
      countryName: 'Sudan',
      countryCode: 'SD',
    },
    {
      countryName: 'Suriname',
      countryCode: 'SR',
    },
    {
      countryName: 'Sweden',
      countryCode: 'SE',
    },
    {
      countryName: 'Switzerland',
      countryCode: 'CH',
    },
    {
      countryName: 'Syria',
      countryCode: 'SY',
    },
    {
      countryName: 'Taiwan',
      countryCode: 'TW',
    },
    {
      countryName: 'Tajikistan',
      countryCode: 'TJ',
    },
    {
      countryName: 'Tanzania',
      countryCode: 'TZ',
    },
    {
      countryName: 'Thailand',
      countryCode: 'TH',
    },
    {
      countryName: 'Timor - Leste',
      countryCode: 'TL',
    },
    {
      countryName: 'Togo',
      countryCode: 'TG',
    },
    {
      countryName: 'Tonga',
      countryCode: 'TO',
    },
    {
      countryName: 'Trinidad and Tobago',
      countryCode: 'TT',
    },
    {
      countryName: 'Tunisia',
      countryCode: 'TN',
    },
    {
      countryName: 'Turkey',
      countryCode: 'TR',
    },
    {
      countryName: 'Turkmenistan',
      countryCode: 'TM',
    },
    {
      countryName: 'Tuvalu',
      countryCode: 'TV',
    },
    {
      countryName: 'Uganda',
      countryCode: 'UG',
    },
    {
      countryName: 'Ukraine',
      countryCode: 'UA',
    },
    {
      countryName: 'UAE',
      countryCode: 'AE',
    },
    {
      countryName: 'UK',
      countryCode: 'GB',
    },
    {
      countryName: 'USA',
      countryCode: 'US',
    },
    {
      countryName: 'Uruguay',
      countryCode: 'UY',
    },
    {
      countryName: 'Uzbekistan',
      countryCode: 'UZ',
    },
    {
      countryName: 'Vanuatu',
      countryCode: 'VU',
    },
    {
      countryName: 'Vatican City',
      countryCode: 'VA',
    },
    {
      countryName: 'Venezuela',
      countryCode: 'VE',
    },
    {
      countryName: 'Vietnam',
      countryCode: 'VN',
    },
    {
      countryName: 'Yemen',
      countryCode: 'YE',
    },
    {
      countryName: 'Zambia',
      countryCode: 'ZM',
    },
    {
      countryName: 'Zimbabwe',
      countryCode: 'ZW',
    },
  ];
  public STRIPE_ELIGLIBLE_COUNTRY_LIST = [
    {
      countryName: 'Australia',
      countryCode: 'AU',
    },
    {
      countryName: 'Austria',
      countryCode: 'AT',
    },
    {
      countryName: 'Belgium',
      countryCode: 'BE',
    },
    {
      countryName: 'Brazil',
      countryCode: 'BR',
    },
    {
      countryName: 'Bulgaria',
      countryCode: 'BG',
    },
    {
      countryName: 'Canada',
      countryCode: 'CA',
    },
    {
      countryName: 'Cyprus',
      countryCode: 'CY',
    },
    {
      countryName: 'Czechia',
      countryCode: 'CZ',
    },
    {
      countryName: 'Denmark',
      countryCode: 'DK',
    },
    {
      countryName: 'Estonia',
      countryCode: 'EE',
    },
    {
      countryName: 'Finland',
      countryCode: 'FI',
    },
    {
      countryName: 'France',
      countryCode: 'FR',
    },
    {
      countryName: 'Germany',
      countryCode: 'DE',
    },
    {
      countryName: 'Greece',
      countryCode: 'GR',
    },
    {
      countryName: 'Hong Kong',
      countryCode: 'HK',
    },
    {
      countryName: 'Hungary',
      countryCode: 'HU',
    },
    // {
    //   "countryName": "India",
    //   "countryCode": "IN"
    // },
    {
      countryName: 'Ireland',
      countryCode: 'IE',
    },
    {
      countryName: 'Italy',
      countryCode: 'IT',
    },
    {
      countryName: 'Japan',
      countryCode: 'JP',
    },
    {
      countryName: 'Latvia',
      countryCode: 'LV',
    },
    {
      countryName: 'Lithuania',
      countryCode: 'LT',
    },
    {
      countryName: 'Luxembourg',
      countryCode: 'LU',
    },
    {
      countryName: 'Malaysia',
      countryCode: 'MY',
    },
    {
      countryName: 'Malta',
      countryCode: 'MT',
    },
    {
      countryName: 'Mexico',
      countryCode: 'MX',
    },
    {
      countryName: 'Netherlands',
      countryCode: 'NL',
    },
    {
      countryName: 'New Zealand',
      countryCode: 'NZ',
    },
    {
      countryName: 'Norway',
      countryCode: 'NO',
    },
    {
      countryName: 'Poland',
      countryCode: 'PL',
    },
    {
      countryName: 'Portugal',
      countryCode: 'PT',
    },
    {
      countryName: 'Romania',
      countryCode: 'RO',
    },
    {
      countryName: 'Singapore',
      countryCode: 'SG',
    },
    {
      countryName: 'Slovakia',
      countryCode: 'SK',
    },
    {
      countryName: 'Slovenia',
      countryCode: 'SI',
    },
    {
      countryName: 'Spain',
      countryCode: 'ES',
    },
    {
      countryName: 'Sweden',
      countryCode: 'SE',
    },
    {
      countryName: 'Switzerland',
      countryCode: 'CH',
    },
    {
      countryName: 'UAE',
      countryCode: 'AE',
    },
    {
      countryName: 'UK',
      countryCode: 'GB',
    },
    {
      countryName: 'USA',
      countryCode: 'US',
    },
  ];

  public TERMS_AND_CONDITIONS = {
    TNC_CONTENT_1 : [
      {
        data : "TERMS OF SERVICE",
        type : "H1"
      },
      {
        data : "DATED: AUGUST 10, 2020",
        type : "D1"
      },
      {
        data : "Welcome to WindowSwap!",
        type : "H2",
        id : 'introduction'
      },
      {
        data : "Introduction",
        type : "H3"
      },
      {
        data : "Thank you for using the WindowSwap platform and the products, services and features we make available to you as part of the platform (collectively, the “Service”).",
        type : "H4"
      },
      {
        data : "Our Service",
        type : "H3"
      },
      {
        data : "The Service allows you to discover, watch and share videos and other content, providing people the ability to inspire others across the globe, and acts as a distribution platform for original content creators and advertisers.",
        type : "H4"
      },
      {
        data : "Your Service Provider",
        type : "H3"
      },
      {
        data : "The entity providing the Service is Window Swap Limited, a company incorporated under Hong Kong law in Hong Kong (registration number 2966137), whose registered address is UNIT 2A, 17/F, GLENEALY TOWER, NO.1, GLEANELY CENTRAL, HONG KONG (referred to as \"WindowSwap\", \"we\", or \"our\").",
        type : "H4"
      },
      {
        data : "Applicable Terms",
        type : "H3"
      },
      {
        data : "Your use of the Service is subject to these terms which may be updated from time to time (together, this \"Agreement\"). Please read this Agreement carefully and make sure you understand it. If you do not understand the Agreement, or do not accept any part of it, then you may not use the Service.",
        type : "H4"
      },
      {
        data : "Use of the Service",
        type : "H2",
        id : 'useOfService'
      },
      {
        data : "Content on the Service",
        type : "H3"
      },
      {
        data : "The content on the Service includes videos, audio (for example music and other sounds), graphics, photos, text (such as comments and scripts), branding (including trade names, trademarks, service marks, or logos), interactive features, software, metrics, and other materials whether provided by you, WindowSwap or a third-party (collectively, \"Content\”). Content is the responsibility of the person or entity that provides it to the Service. WindowSwap is under no obligation to host or serve Content. If you see any Content you believe does not comply with this Agreement, including by violating the law, you can report it to us by emailing qunaliaa@gmail.com",
        type : "H4"
      },
      {
        data : "Your Information",
        type : "H3"
      },
      {
        data : "Our Privacy Policy explains how we treat your personal data and protect your privacy when you use the Service.",
        type : "H4"
      },
      {
        data : "Permissions and Restrictions",
        type : "H3"
      },
      {
        data : "You may access and use the Service as made available to you, as long as you comply with this Agreement and applicable law. You may view or listen to Content for your personal, non-commercial use.",
        type : "H4"
      },
      {
        data : "The following restrictions apply to your use of the Service. You are not allowed to:",
        type : "H4"
      },
      
    ],
    TNC_CONTENT_2 : [
      {
        data : "Access, reproduce, download, distribute, transmit, broadcast, display, sell, license, alter, modify or otherwise use any part of the Service or any Content except: (a) as expressly authorized by the Service; or (b) with prior written permission from WindowSwap and, if applicable, the respective rights holders;",
        type : "H4"
      },
      {
        data : "Circumvent, disable, fraudulently engage with, or otherwise interfere with any part of the Service (or attempt to do any of these things), including security-related features or features that (a) prevent or restrict the copying or other use of Content or (b) limit the use of the Service or Content;",
        type : "H4"
      },
      {
        data : "Access the Service using any automated means (such as robots, botnets or scrapers) except (a) in the case of public search engines, in accordance with WindowSwap\’s robots.txt file; or (b) with WindowSwap\’s prior written permission;",
        type : "H4"
      },
      {
        data : "Collect or harvest any information that might identify a person(s)",
        type : "H4"
      },
      {
        data : "Use the Service to distribute unsolicited promotional or commercial content or other unwanted or mass solicitations;",
        type : "H4"
      },
      {
        data : "Cause or encourage any inaccurate measurements of genuine user engagement with the Service, or otherwise manipulate metrics in any manner:",
        type : "H4"
      },
      {
        data : "Misuse any reporting, flagging, complaint, dispute, or appeals process, including by making groundless, vexatious, or frivolous submissions;",
        type : "H4"
      },
      {
        data : "Use the Service to view or listen to Content other than for personal, non-commercial use (for example, you may not publicly screen videos or stream music from the Service); or",
        type : "H4"
      },
      {
        data : "Use the Service to sell any advertising, sponsorships, or promotions placed on, around, or within the Service or Content",
        type : "H4"
      },

    ],
    TNC_CONTENT_3 : [
      {
        data : "Reservation",
        type : "H3"
      },
      {
        data : "Using the Service does not give you ownership of or rights to any aspect of the Service, including user names or any other Content posted by others or WindowSwap.",
        type : "H4"
      },
      {
        data : "Changes to the Service",
        type : "H3"
      },
      {
        data : "WindowSwap is constantly changing and improving the Service. We may also need to alter or discontinue the Service, or any part of it, in order to make performance or security improvements, change functionality and features, make changes to comply with law, or prevent illegal activities on or abuse of our systems. These changes may affect all users, some users or even an individual user. Whenever reasonably possible, we will provide notice when we discontinue or make material changes to our Service that will have an adverse impact on the use of our Service. However, you understand and agree that there will be times when we make such changes without notice, such as where we feel we need to take action to improve the security and operability of our Service, prevent abuse, or comply with legal requirements.",
        type : "H4"
      },
      {
        data : "Your Content and Conduct",
        type : "H2",
        id : 'yourContentAndConduct'
      },
      {
        data : "Uploading Content",
        type : "H3"
      },
      {
        data : "If you choose to send us your Content, you must not submit to the Service any Content that does not comply with this Agreement or the law. For example, the Content you submit must not include third-party intellectual property (such as copyrighted material) unless you have permission from that party or are otherwise legally entitled to do so. You are legally responsible for the Content you submit to the Service. We may use a manual review or an automated system that analyzes your Content to help detect infringement and abuse, such as spam, malware, and illegal content. WindowSwap will have the sole right to determine what Content gets uploaded to the Service and for what duration.",
        type : "H4"
      },
      {
        data : "Rights you Grant",
        type : "H3"
      },
      {
        data : "You retain ownership rights to your Content. However, we do require you to grant certain rights to WindowSwap and other users of the Service, as described below.",
        type : "H4"
      }, {
        data : "License to WindowSwap",
        type : "H3"
      }, {
        data : "By providing Content to the Service, you grant to WindowSwap a worldwide, non-exclusive, royalty-free, sublicensable and transferable license to use that Content anywhere and on any other website or media (including to reproduce, distribute, publish, prepare derivative works, display and perform it commercially) in connection with the Service and WindowSwap\’s (and its successors' and Affiliates') business, including for the purpose of promoting and redistributing part or all of the Service.",
        type : "H4"
      }, {
        data : "License to Other Users",
        type : "H3"
      }, {
        data : "You also grant each other user of the Service a worldwide, non-exclusive, royalty-free license to access your Content through the Service, and to use that Content, including to reproduce, distribute, prepare derivative works, display, and perform it, only as enabled by a feature of the Service (such as video playback, embeds and social sharing). For clarity, this license does not grant any rights or permissions for a user to make use of your Content independent of the Service.",
        type : "H4"
      },
      {
        data : "Duration of License",
        type : "H3"
      },
      {
        data : "The licenses (as mentioned under License to WindowSwap) granted by you continue for a commercially reasonable period of time (at the minimum for one year after the date of removal) after you remove or delete your Content from the Service. You understand and agree, however, that windowSwap may retain, but not display, distribute, or perform, server copies of your videos that have been removed or deleted.",
        type : "H4"
      },
      {
        data : "Removing Your Content",
        type : "H3"
      },
      {
        data : "You may request the removal of your Content from the Service at any time by emailing qunaliaa@gmail.com. You must request removal of your Content if you no longer have the rights required by these terms.",
        type : "H4"
      },
      {
        data : "Removal of Content By WindowSwap",
        type : "H3"
      },
      {
        data : "If we reasonably believe that any Content is in breach of this Agreement or may cause harm to WindowSwap, our users, or third parties, we may remove or take down that Content in our discretion.",
        type : "H4"
      },
      {
        data : "Copyright Protection",
        type : "H3"
      },
      {
        data : "If you believe your copyright has been infringed on the Service, please email us at qunaliaa@gmail.com.",
        type : "H4"
      },
      {
        data : "Termination of Service",
        type : "H3"
      },
      {
        data : "WindowSwap may terminate all or part of the Service, in its sole discretion, at any point in time.",
        type : "H4"
      },
      {
        data : "Other Legal Terms",
        type : "H2",
        id : 'otherLegalTerms'
      },
      {
        data : "Warranty Disclaimer",
        type : "H3"
      },
      {
        data : "OTHER THAN AS EXPRESSLY STATED IN THIS AGREEMENT OR AS REQUIRED BY LAW, THE SERVICE IS PROVIDED “AS IS” AND WINDOWSWAP DOES NOT MAKE ANY SPECIFIC COMMITMENTS OR WARRANTIES ABOUT THE SERVICE. FOR EXAMPLE, WE DON\’T MAKE ANY WARRANTIES ABOUT: (A) THE CONTENT PROVIDED THROUGH THE SERVICE; (B) THE SPECIFIC FEATURES OF THE SERVICE, OR ITS ACCURACY, RELIABILITY, AVAILABILITY, OR ABILITY TO MEET YOUR NEEDS; OR (C) THAT ANY CONTENT YOU SUBMIT WILL BE ACCESSIBLE ON THE SERVICE.",
        type : "H4"
      },
      {
        data : "Limitation of Liability",
        type : "H3"
      },
      {
        data : "EXCEPT AS REQUIRED BY APPLICABLE LAW, WINDOWSWAP, ITS AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES AND AGENTS WILL NOT BE RESPONSIBLE FOR ANY LOSS OF PROFITS, REVENUES, BUSINESS OPPORTUNITIES, GOODWILL, OR ANTICIPATED SAVINGS; LOSS OR CORRUPTION OF DATA; INDIRECT OR CONSEQUENTIAL LOSS; PUNITIVE DAMAGES CAUSED BY:",
        type : "H4"
      },
    ],
    TNC_CONTENT_4 : [
      {
        data : "ERRORS, MISTAKES, OR INACCURACIES ON THE SERVICE;",
        type : "H4"
      },
      {
        data : "PERSONAL INJURY OR PROPERTY DAMAGE RESULTING FROM YOUR USE OF THE SERVICE;",
        type : "H4"
      },
      {
        data : "ANY UNAUTHORIZED ACCESS TO OR USE OF THE SERVICE;",
        type : "H4"
      },
      {
        data : "ANY INTERRUPTION OR CESSATION OF THE SERVICE;",
        type : "H4"
      },
      {
        data : "ANY VIRUSES OR MALICIOUS CODE TRANSMITTED TO OR THROUGH THE SERVICE BY ANY THIRD PARTY;",
        type : "H4"
      },
      {
        data : "ANY CONTENT WHETHER SUBMITTED BY A USER OR WINDOWSWAP, INCLUDING YOUR USE OF CONTENT; AND/OR",
        type : "H4"
      },
      {
        data : "THE REMOVAL OR UNAVAILABILITY OF ANY CONTENT.",
        type : "H4"
      },
   
    ],
    TNC_CONTENT_5 : [
      {
        data : "THIS PROVISION APPLIES TO ANY CLAIM, REGARDLESS OF WHETHER THE CLAIM ASSERTED IS BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY.",
        type : "H4"
      },
      {
        data : "WINDOWSWAP AND ITS AFFILIATES\’ HAVE NO LIABILITY FOR ANY CLAIMS ARISING FROM OR RELATING TO THE SERVICE.",
        type : "H4"
      },
      {
        data : "Indemnity",
        type : "H3"
      },
      {
        data : "To the extent permitted by applicable law, you agree to defend, indemnify and hold harmless WindowSwap, its Affiliates, officers, directors, employees and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from: (i) your use of and access to the Service; (ii) your violation of any term of this Agreement; (iii) your violation of any third party right, including without limitation any copyright, property, or privacy right; or (iv) any claim that your Content caused damage to a third party. This defense and indemnification obligation will survive this Agreement and your use of the Service.",
        type : "H4"
      },
      {
        data : "Third-Party Links",
        type : "H3"
      },
      {
        data : "The Service may contain links to third-party websites and online services that are not owned or controlled by WindowSwap. WindowSwap has no control over, and assumes no responsibility for, such websites and online services. Be aware when you leave the Service; we suggest you read the terms and privacy policy of each third-party website and online service that you visit.",
        type : "H4"
      },
      {
        data : "About this Agreement",
        type : "H2"
      },
      {
        data : "Modifying this Agreement",
        type : "H3"
      },
      {
        data : "We may modify this Agreement, for example, to reflect changes to our Service or for legal, regulatory, or security reasons. Modifications to this Agreement will only apply going forward. If you do not agree to the modified terms, you should request removal of any Content you may have uploaded and discontinue your use of the Service.",
        type : "H4"
      },
      {
        data : "Continuation of this Agreement",
        type : "H3"
      },
      {
        data : "If your use of the Service ends, the following terms of this Agreement will continue to apply to you: “Other Legal Terms”, “About This Agreement”, and the licenses granted by you will continue as described under “Duration of License”.",
        type : "H4"
      },
      {
        data : "Severance",
        type : "H3"
      },
      {
        data : "If it turns out that a particular term of this Agreement is not enforceable for any reason, this will not affect any other terms.",
        type : "H4"
      },
      {
        data : "No Waiver",
        type : "H3"
      },
      {
        data : "If you fail to comply with this Agreement and we do not take immediate action, this does not mean that we are giving up any rights that we may have (such as the right to take action in the future).",
        type : "H4"
      },
      {
        data : "Interpretation",
        type : "H3"
      },
      {
        data : "In these terms, “include” or “including” means “including but not limited to,” and any examples we give are for illustrative purposes.",
        type : "H4"
      },
      {
        data : "Governing Law",
        type : "H3"
      },
      {
        data : "These T&C and any matters relating hereto shall be governed by, and construed in accordance with, the laws of Hong Kong. Each party irrevocably agrees that the relevant courts of Hong Kong shall have the exclusive jurisdiction in relation to any claim, dispute, or difference concerning these T&C and any matter arising therefrom and irrevocably waives any right that it may have to object to an action being brought in those courts, or to claim that the action has been brought in an inconvenient forum, or that those courts do not have jurisdiction. Your use of the Services may also be subject to other local, state, national, or international laws.",
        type : "H4.1"
      },
      {
        data : "We and You each agree that if You are a user of Services located in the United States or Canada, each of We and You may bring disputes against the other only on its or Your own behalf, and not on behalf of any other person or entity, or any class of people. We and You each agree not to participate in a class action, a class-wide arbitration, disputes brought in a private attorney general or representative capacity, or consolidated disputes involving any other person or entity in connection with any dispute.",
        type : "H4"
      },
      {
        data : "Limitation on Legal Action",
        type : "H3"
      },
      {
        data: "YOU AND WINDOWSWAP AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICES MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.",
        type: "H4"
      },
      {
        data: "Privacy Policy",
        type: "H2",
        id: 'privacyPolicy'
      },

      {
        data: "We believe you should always know what data we collect from you and how we use it, and that you should have meaningful control over both. Definitions of terms used in this privacy policy can be seen at window-swap.com/terms",
        type: "H4"
      },
      {
        data: "1 Information You Share With Us",
        type: "H3"
      },
      {
        data: "We require certain information to provide our services to you. For example, you must send us an email with the Content in order for us to upload the Content and operate the Service. If you are a visitor to the site, you can use the site without creating an account or logging in. However, by virtue of this we collect specific information that will be discussed later.",
        type: "H4"
      },
      {
        data: "We require certain information to provide our services to you. For example, you must send us an email with the Content in order for us to upload the Content and operate the Service.",
        type: "H4.1"
      },
      {
        data: "If you are a visitor to the site, you can use the site without creating an account or logging in. However, by virtue of this we collect specific information that will be discussed later.",
        type: "H4"
      },
      {
        data: "1.1 Basic Information",
        type: "H4.2"
      },
      {
        data : "You don\’t have to create an account to use our Service, such as viewing videos or even uploading videos. When you send us a video we protect your privacy by only using your first name while displaying the video on the site. We also display the location you choose to share while sending us your video.",
        type : "H4"
      },
      {
        data : "1.2 Contact Information",
        type : "H4.2"
      },
      {
        data : "We may use your contact information, such as your email address, to send you information about our services from time to time.",
        type : "H4"
      },
      {
        data : "1.3 Payment Information",
        type : "H4.2"
      },
      {
        data : "We do not charge for the Service. Do not provide any payment information while using the Service.",
        type : "H4"
      },
      {
        data : "2 Additional Information We Receive About You",
        type : "H3"
      },
      {
        data : "We receive certain information when you use our services. Like the information you share with us, we use the data below to operate our services.",
        type : "H4"
      },
      {
        data : "2.1 Location Information",
        type : "H4.2"
      },
      {
        data : "Subject to your settings, we may collect, use, and store additional information about your location - such as your current precise position - to operate or personalize our services.",
        type : "H4"
      },
      {
        data : "2.2 Links",
        type : "H4.2"
      },
      {
        data : "In order to operate our services, we keep track of how you interact with links across the service. This includes links in emails we may send you and links that appear on the website.",
        type : "H4.1"
      },
      {
        data : "If you click on an external link or ad on our services, that advertiser or website operator might figure out that you came from window-swap.com, along with other information associated with the ad you clicked such as characteristics of the audience it was intended to reach. They may also collect other personal data from you, such as cookie identifiers or your IP address.",
        type : "H4"
      },
      {
        data : "2.3 Cookies",
        type : "H4.2"
      },
      {
        data : "A cookie is a small piece of data that is stored on your computer or mobile device. Like many websites, we use cookies and similar technologies to collect additional website usage data and to operate our services. Cookies are not required for many parts of our services such as viewing videos. Although most web browsers automatically accept cookies, many browsers’ settings can be set to decline cookies or alert you when a website is attempting to place a cookie on your computer. However, some of our services may not function properly if you disable cookies. When your browser or device allows it, we use both session cookies and persistent cookies to better understand how you interact with our services, to monitor aggregate usage patterns, and to personalize and otherwise operate our services.",
        type : "H4"
      },
      {
        data : "2.4 Log Data",
        type : "H4.2"
      },
      {
        data : "We receive information when you view content on or otherwise interact with our services, which we refer to as “Log Data”. This Log Data includes information such as your IP address, browser type, operating system, the referring web page, pages visited, location, your mobile carrier, device information (including device and application IDs), search terms (including those not submitted as queries), and cookie information. We use Log Data to operate our services and ensure their secure, reliable, and robust performance.",
        type : "H4"
      },
      {
        data : "2.5 Advertisers and Other Ad Partners",
        type : "H4.2"
      },
      {
        data : "WIndow-swap does not operate an advertising model today, however, we may start doing this in the future. Advertising revenue will allow us to support and improve our services. We may use the information described in this Privacy Policy to help make our advertising more relevant to you, to measure its effectiveness, and to help recognize your devices to serve you ads on and off of window-swap.com. Our ad partners and affiliates may share information with us such as browser cookie IDs, mobile device IDs, hashed email addresses, demographic or interest data, and content viewed or actions taken on a website or app. Information shared by ad partners and affiliates or collected by us from the websites and apps of ad partners and affiliates may be combined with the other information you share and that we receive about you described elsewhere in our Privacy Policy.",
        type : "H4"
      },
      {
        data : "3.0 Service Providers",
        type : "H3"
      },
      {
        data : "We engage service providers to perform functions and provide services for us. For example, we use Vimeo to host the Video content. We also use tools like Google Analytics to measure and monitor traffic and site usage. We may share your private personal data with such service providers subject to obligations consistent with this Privacy Policy and any other appropriate confidentiality and security measures, and on the condition that the third parties use your private personal data only on our behalf and pursuant to our instructions (service providers may use other non-personal data for their own benefit).",
        type : "H4"
      },
      {
        data : "4.0 Affiliates and Change of Ownership",
        type : "H3"
      },
      {
        data : "In the event that we are involved in a bankruptcy, merger, acquisition, reorganization, or sale of assets, your personal data may be sold or transferred as part of that transaction. This Privacy Policy will apply to your personal data as transferred to the new entity.",
        type : "H4"
      },
      {
        data : "5 Managing Your Personal Information With Us",
        type : "H3"
      },
      {
        data : "If you wish to delete your personal information from the Service you can email us at qunaliaa@gmail.com",
        type : "H4"
      },
      {
        data : "6 Children and our services",
        type : "H3"
      },
      {
        data : "Our services are not directed to children, and you may not use our services if you are under the age of 16, unless you are with a family member or teacher.",
        type : "H4"
      },
      {
        data : "7 Changes to This Privacy Policy",
        type : "H3"
      },
      {
        data : "We may revise this Privacy Policy from time to time. The most current version of the policy will govern our processing of your personal data and will always be at https://window-swap.com/privacy. If we make a change to this policy that, in our sole discretion, is material, we will notify you within Twitter.com (@windowswap), or by sending an email to the email address associated with your account. By continuing to access or use the Services after those changes become effective, you agree to be bound by the revised Privacy Policy.",
        type : "H4"
      },
      {
        data : "Effective: August 10, 2020",
        type : "H4.2"
      },
    ]
  }


  // Links and url's
  public INSTAGRAM_LINK = 'https://www.instagram.com/windowswap/';
  public BLOG_LINK = 'http://windowswapblog.squarespace.com/';
  public SUPPORT_LINK = 'https://www.buymeacoffee.com/windowswap';
  public HOME_LINK1_LINK =
    'https://docs.google.com/forms/d/e/1FAIpQLSejfx_Hzbzd_tSsckPOC4LFL9byHfQRW3lD4j9uWLX4hdluig/viewform?usp=sf_link';
  public TERMS_CONDITIONS_LINK =
    '/terms';
  public SUBMIT_WINDOW_LINK = 'https://forms.gle/bEjLZkNE3HweT6u36';
  public SUPER_USER = ["sonaliranjit@gmail.com", "qunaliaa@gmail.com", "vaishusparty@gmail.com","sourav.nambiar@techpearl.com","sudarshan.muddamsetti@techpearl.com"]
  public ALREADY_IN_LIVE = 'Already in live videos';
  public FETCH_ERROR = 'Fetch Error!';
  public ASYNC_FETCH_ERROR = 'Async Fetch Error!';
  public UPDATION_ERROR = 'Updation Error!';
  public UPGRADE_5_NEW = 'Upgrade for $5'
  public This_ADS_HELP = 'Every upgrade helps keep WindowSwap alive'
  public No_ADS_EVER = 'No Ads ever with';
  public UPGRADE_FOR_PLAYLIST_MAPS = 'Upgrade for access to Window Playlists, Unlimited Bookmarks, Maps, Window Search and more.'
  public UPGRADE = 'Upgrade';
  public RESEND_BUTTON_TEXT = "Resend Link";
  public CURATED_SUCCESS ="Curated successfully";
  public UNCURATED_SUCCESS ="Uncurated successfully";
  public UPLOADED_VIDEOS_TITLE = "All Videos";
  public CURATED_VIDEOS_TITLE = "Curated Videos";
  public SUCCESS = 'SUCCESS';

    public WS_GIFT = 'assets/images/Gift.png';
    public WS_GIFT_HOME = 'assets/images/GiftHome.png';
    public WS_NYT_LOGO = 'assets/images/NYT_LOGO.png';
    public WS_GALLERY = 'assets/images/Gallery.png';
    public WS_FAV = 'assets/images/fav.png';
    public WS_INSTA_GIFTING = 'assets/images/Instagram_gifting.png';
    public WS_NEWS_GIFTING = 'assets/images/News_gifting.png';
    public WS_CONTACT_GIFTING = 'assets/images/contact_gifting.png';
    public WS_TERMS_GIFTING = 'assets/images/Terms_gifting.png';
    public GIFT = "Gift";
    public ALL_ACCESS = "All-Access";
    public GIVE_ALL_OF_WINDOW = "Give all of WindowSwap";
    public SOME_ONE_YOU_LOVE = "to someone you love";
    public SEND_GIFT = "Send a Gift";
    public GIFT_WINDOWSWAP = "Gift WindowSwap";
    public GIVE_ALL_OF_WINDOWSWAP_LOVE = "Give all of WindowSwap to someone you love.";
    public BEST_GIFTS_FOR = '“...Best Gifts for';
    public FREQUENT_TRAVELERS = 'Frequent Travellers”';
    public SOME_TIMES_TEXT = '“Sometimes the best gift is to remind someone';
    public SOME_TIMES_TEXT_MOBILE = '“Sometimes the best gift is to remind';
    public WORLD_LARGER_TEXT = 'that the world is both larger and more';
    public WORLD_LARGER_TEXT_MOBILE = 'someone that the world is both larger and';
    public ACESSIBLE_TEXT = 'accessible than they realize"';
    public ACESSIBLE_TEXT_MOBILE = 'more accessible than they realize"';
    public NYT_WIRECUTTER = 'NYT Wirecutter';
    public GIFT_SOME_FOCUS = 'A Gift of focus';
    public CALMEST_PLACE = 'A Gift of Calm';
    public TRAVEL_WORLD = 'A Gift of Infinite Travel';
    public THOUSANDS_TEXT = "Thousands use WindowSwap <br> to focus while working or studying";
    public COMMUNITY_LIVES = "A community that lives in the calmest place <br> online, escaping the chaos of the internet";
    public EVERY_DAY_SIDES = "Everyday we see sides of the world <br> we've never seen before";
    public GIFT_CHECKOUT_SECTIONS = {
        "SECTION1":"Your Details",
        "SECTION2":"Personalise",
        "SECTION3":"Billing"
    }
    public GIFT_LOGIN_TXT = "Log in";
    public NO_ACCOUNT = "No account? ";
    public CREATE_ONE_HERE = "Create one here";
    public USER_IS_NOT_CONFIRMED = "User is not confirmed.";
    public RESEND_VERI_CODE = "Resend verification code Confirmation.";
    public ENTER_EMAIL_ID = "Please enter an email ID";
    public INVALID_EMAIL_ID = "Invalid email ID";
    public ENTER_PASSWORD = "Please enter a password";
    public FORGOT_PASSWORD = "Forgot your password?";
    public ENTER_EMAIL_TXT = "Enter the email address associated with your account and we will send you a link to reset your password.";
    public VERIFY_TXT = "Verify";
    public ENTER_VERIFICATION_CODE = "Enter the verification code emailed to you, and then create a new password";
    public PLEASE_ENTER_VERIFICATION_CODE = "Please enter the Verification code";
    public ALREADY_HAS_SUBSCRIPTION = "Uh oh, looks like they already have a subscription with us.";
    public WHO_IS_THIS_GIFT_FOR = "Who is this gift for?";
    public EMAIL_IS_REQUIRED = "Email is required";
    public NEXT = "Next";
    public RECEIPIENT_NAME = "Recipient's Full Name";
    public RECEIPIENT_NAME_REQUIRED = "Recipient's name is required";
    public MAX_LENGTH_100 = "Max 100 characters";
    public WHO_THIS_GIFT_FROM = "Who is this gift from?";
    public SENDER_NAME_REQUIRED = "Sender's Name is required";
    public GIFT_DELIVERY_DATE = "Gift Delivery Date";
    public DELIVERY_DATE_REQUIRED = "Delivery date is required";
    public MESSAGE = "Message";
    public MESSAGE_TEXT = "Write a personal message to send along with the gift subscription email.";
    public MESSAGE_REQUIRED = "Message is required";
    public MAX_LENGTH_500 = "Max 500 characters";
    public ONE_TIME_CHARGE = "This is a one-time charge";
    public OR_TXT = "or";
    public PAY_USD_50 = "Pay USD 50";
    public GIFT_WRAPPED = "Your gift is being wrapped!";
    public YOUR_GIFT_IS = "Your gift is";
    public BEING_WRAPPED = "being wrapped!";
    public GIFT_TXNS_1 = "Thanks for spreading the calm";
    public GIFT_TXNS_2 = "with the wonderful gift of WindowSwap!";
    public GIFT_TXNS_3 = "You'll receive an email confirmation soon.";
    public BACK_HOME_LG = "Go Back Home";
    public BACK_HOME_SM = "Back Home";
    public COGNITO_ERRORS = {
      USER_NOTCONFIRMED: "UserNotConfirmedException",
      NOT_AUTHORIED: "NotAuthorizedException"
    }
    public giftType = {
      today:1,
      scheduled:2
    }
    public CHECKING_EMAIL = "Checking Email   ";
    public VIMEO_DEFAULT_THUMBNAIL = "https://i.vimeocdn.com/video/default-2308240_295x166?&region=us";
    public RETRY = "Retry upload to vimeo";

    public ASYNC_CALL_TIME = {
      INITIAL_INTERVAL: 1000,
      INCREMENT_INTERVAL: 15000,
      MAX_RETRIES: 20
    }

    public CURATION_STATUS = {
      curated: 1,
      pending: 2,
      failed: 3
    }

    public GAZE_DELETE_ACCOUNT_CONTENT = {
      headerTitle: 'Deleting Your Account',
      description: 'You can delete your Window Swap account from the Account Details page.',
    howToDelete: {
      title: 'How to Delete Your Account',
      steps: [
        'Open Account Settings.',
        'Select Account Details.',
        'Tap Delete Account.',
        'Review the confirmation message.',
        'Confirm that you want to delete your account.'
      ]
    },
    important: {
      title: 'Important',
      items: [
        'Account deletion is permanent and cannot be undone.',
        'All data associated with your account will be removed.',
        'You will be automatically signed out and redirected to the login screen.'
      ]
    },
    whatWillBeDeleted: {
      title: 'What Data Will Be Deleted?',
      subtitle: 'Deleting your account removes:',
      items: [
        'Your Window Swap account',
        'Bookmarks',
        'Submissions',
        'Gaze reflections',
        'Any other account-related data stored within Window Swap'
      ],
      footer: 'Deleted data cannot be recovered.'
    }
  };

  public GAZE_SUPPORT_CONTENT = {
    headerTitle: 'Support & Help Center',
    card: {
      title: 'Need help?',
      description: "Email us and we'll get back to you within 1-5 days.",
      email: 'qunaliaa@gmail.com'
    },
    sections: [
      {
        title: 'How Can We Help?',
        items: [
          'General questions about Window Swap',
          'Account access and login issues',
          'Subscription and billing inquiries',
          'Submission and bookmark-related issues',
          'Gaze-related questions and feedback',
          'Technical issues and troubleshooting',
          'Privacy, data, and account deletion requests',
          'Feedback, suggestions, and partnership inquiries'
        ]
      }
    ],
    faqTitle: 'Frequently Asked Questions',
    faqs: [
      {
        question: 'How do I cancel my subscription?',
        answer: "Subscriptions are billed through the Apple App Store or Google Play. To cancel, go to your device's Subscriptions settings (Settings > [your name] > Subscriptions on iPhone, or Google Play > Payments & subscriptions on Android)."
      },
      {
        question: 'How do I request a refund?',
        answer: 'Refunds are handled directly by Apple or Google, not WindowSwap, since purchases are processed through their billing systems. Contact Apple or Google support to request one.'
      },
      {
        question: 'How do I delete my content or account?',
        answer: "You can also delete your account directly within the 'Account Settings' page in the App. Alternatively, email us at qunaliaa@gmail.com and we'll remove your content."
      },
      {
        question: 'How do I report inappropriate content?',
        answer: "Email us at qunaliaa@gmail.com with a description or link to the content, and we'll review it promptly."
      }
    ],
    resourcesTitle: 'More Resources',
    resources: [
      { text: 'Terms of Service', route: '/gaze-terms' },
      { text: 'Privacy Policy', route: '/gaze-privacy' },
      { text: 'Manage Subscription (Apple)', url: 'https://apps.apple.com/account/subscriptions' },
      { text: 'Manage Subscription (Google Play)', url: 'https://play.google.com/store/account/subscriptions' }
    ]
  };

  public GAZE_FOOTER_CONTENT = {
    footer: {
      company: 'Window Swap Limited · Hong Kong (Reg. No. 2966137)',
      copyright: '© 2026 WindowSwap. All rights reserved.'
    }
  };

  public COMMUNITY_QUOTES = [{
    quote: "Helps me to relax and focus \n on just this and nothing else.",
    user : "Gracie, USA"
  },
  {
    quote: "when I need a break from life \n aka meditation.",
    user : "Rui, China"
  },
  {
    quote: "WindowSwap allows me to relax \n and calm down after a long day.",
    user : "David, Argentina"
  },
  {
    quote: "Helps me reflect.",
    user : "Gabby, Brazil" 
  }]
}
